var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _path82, _path83, _g14, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _g15, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _g16, _path286, _path287, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDualToken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1135,
    height: 684,
    viewBox: "0 0 1135 684",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 194,
    y: 189,
    width: 368,
    height: 368,
    fill: "url(#pattern0)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M365.707 523.362C449.06 523.362 516.631 506.006 516.631 484.596C516.631 463.185 449.06 445.829 365.707 445.829C282.354 445.829 214.783 463.185 214.783 484.596C214.783 506.006 282.354 523.362 365.707 523.362Z",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M365.706 518.71C438.976 518.71 498.373 503.436 498.373 484.595C498.373 465.754 438.976 450.48 365.706 450.48C292.436 450.48 233.039 465.754 233.039 484.595C233.039 503.436 292.436 518.71 365.706 518.71Z",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M365.707 514.059C428.99 514.059 480.291 500.868 480.291 484.596C480.291 468.324 428.99 455.133 365.707 455.133C302.424 455.133 251.123 468.324 251.123 484.596C251.123 500.868 302.424 514.059 365.707 514.059Z",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M365.708 509.406C419.004 509.406 462.209 498.298 462.209 484.595C462.209 470.893 419.004 459.785 365.708 459.785C312.412 459.785 269.207 470.893 269.207 484.595C269.207 498.298 312.412 509.406 365.708 509.406Z",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M365.707 504.754C409.016 504.754 444.125 495.729 444.125 484.595C444.125 473.462 409.016 464.437 365.707 464.437C322.398 464.437 287.289 473.462 287.289 484.595C287.289 495.729 322.398 504.754 365.707 504.754Z",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M365.708 500.102C398.934 500.102 425.869 493.159 425.869 484.595C425.869 476.031 398.934 469.088 365.708 469.088C332.482 469.088 305.547 476.031 305.547 484.595C305.547 493.159 332.482 500.102 365.708 500.102Z",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M365.707 495.45C388.946 495.45 407.785 490.59 407.785 484.595C407.785 478.601 388.946 473.741 365.707 473.741C342.468 473.741 323.629 478.601 323.629 484.595C323.629 490.59 342.468 495.45 365.707 495.45Z",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M427.433 485.112C426.216 493.383 400.309 500.102 368.142 500.274V525.774C455.253 525.43 525.673 507.339 526.89 485.112H427.433Z",
    fill: "url(#paint0_radial_2_12269)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M367.968 443.244V468.744C383.269 468.916 397.179 470.467 407.611 472.879L477.857 454.788C449.515 447.723 410.741 443.416 367.968 443.244Z",
    fill: "url(#paint1_radial_2_12269)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M204.699 483.562H304.156C306.069 475.464 331.628 468.916 363.447 468.744V443.244C276.858 443.589 206.612 461.335 204.699 483.562Z",
    fill: "url(#paint2_radial_2_12269)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M319.979 495.106C310.937 492.521 305.025 489.248 304.156 485.457H204.699C205.569 496.139 222.608 505.96 249.733 513.197L319.979 495.106Z",
    fill: "url(#paint3_radial_2_12269)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M365.706 442.899V454.788",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M365.706 514.23V526.291",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M337.539 443.416L345.711 455.305",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M385.877 513.713L393.875 525.602",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M310.066 445.312L326.063 456.683",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M405.351 512.507L421.347 523.707",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M284.508 448.413L307.807 458.751",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M423.608 510.268L447.082 520.606",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M261.207 452.548L291.287 461.852",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M440.125 507.339L470.205 516.471",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M241.211 457.717L277.029 465.47",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M454.383 503.548L490.201 511.301",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M225.041 463.747L265.554 469.605",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M466.032 499.413L506.545 505.443",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M213.045 470.295L257.035 474.43",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M474.553 494.761L518.543 498.724",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M205.566 477.359L251.643 479.426",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M479.769 489.765L525.846 491.832",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M203.133 484.595H249.905",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M481.507 484.595H528.279",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M205.566 491.832L251.643 489.765",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M479.768 479.426L525.845 477.359",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M213.045 498.724L257.035 494.761",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M474.553 474.43L518.543 470.295",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M365.708 536.629C477.869 536.629 568.794 513.333 568.794 484.595C568.794 455.858 477.869 432.562 365.708 432.562C253.546 432.562 162.621 455.858 162.621 484.595C162.621 513.333 253.546 536.629 365.708 536.629Z",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M797.77 525.362C881.122 525.362 948.693 508.006 948.693 486.596C948.693 465.185 881.122 447.829 797.77 447.829C714.417 447.829 646.846 465.185 646.846 486.596C646.846 508.006 714.417 525.362 797.77 525.362Z",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M797.769 520.71C871.039 520.71 930.436 505.436 930.436 486.595C930.436 467.754 871.039 452.48 797.769 452.48C724.5 452.48 665.103 467.754 665.103 486.595C665.103 505.436 724.5 520.71 797.769 520.71Z",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M797.769 516.059C861.052 516.059 912.353 502.868 912.353 486.596C912.353 470.324 861.052 457.133 797.769 457.133C734.486 457.133 683.186 470.324 683.186 486.596C683.186 502.868 734.486 516.059 797.769 516.059Z",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M797.769 511.406C851.065 511.406 894.27 500.298 894.27 486.595C894.27 472.893 851.065 461.785 797.769 461.785C744.473 461.785 701.269 472.893 701.269 486.595C701.269 500.298 744.473 511.406 797.769 511.406Z",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M797.769 506.754C841.078 506.754 876.187 497.729 876.187 486.595C876.187 475.462 841.078 466.437 797.769 466.437C754.46 466.437 719.352 475.462 719.352 486.595C719.352 497.729 754.46 506.754 797.769 506.754Z",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M797.769 502.102C830.995 502.102 857.93 495.159 857.93 486.595C857.93 478.031 830.995 471.088 797.769 471.088C764.543 471.088 737.608 478.031 737.608 486.595C737.608 495.159 764.543 502.102 797.769 502.102Z",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M797.769 497.45C821.008 497.45 839.847 492.59 839.847 486.595C839.847 480.601 821.008 475.741 797.769 475.741C774.53 475.741 755.691 480.601 755.691 486.595C755.691 492.59 774.53 497.45 797.769 497.45Z",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M859.496 487.112C858.278 495.383 832.371 502.102 800.204 502.274V527.774C887.316 527.43 957.735 509.339 958.952 487.112H859.496Z",
    fill: "url(#paint4_radial_2_12269)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M800.03 445.244V470.744C815.331 470.916 829.241 472.467 839.674 474.879L909.919 456.788C881.578 449.723 842.804 445.416 800.03 445.244Z",
    fill: "url(#paint5_radial_2_12269)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M636.762 485.562H736.218C738.131 477.464 763.691 470.916 795.51 470.744V445.244C708.92 445.589 638.674 463.335 636.762 485.562Z",
    fill: "url(#paint6_radial_2_12269)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M752.041 497.106C743 494.521 737.088 491.248 736.218 487.457H636.762C637.631 498.139 654.671 507.96 681.795 515.197L752.041 497.106Z",
    fill: "url(#paint7_radial_2_12269)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M797.77 444.899V456.788",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M797.77 516.23V528.291",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M769.603 445.416L777.775 457.305",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M817.94 515.713L825.939 527.602",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M742.13 447.312L758.126 458.683",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M837.414 514.507L853.411 525.707",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M716.57 450.413L739.87 460.751",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M855.671 512.268L879.144 522.606",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M693.271 454.548L723.351 463.852",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M872.188 509.339L902.269 518.471",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M673.275 459.717L709.094 467.47",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M886.447 505.548L922.266 513.301",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M657.104 465.747L697.617 471.605",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M898.096 501.413L938.609 507.443",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M645.107 472.295L689.098 476.43",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M906.615 496.761L950.606 500.724",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M637.63 479.359L683.707 481.426",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M911.832 491.765L957.909 493.832",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M635.196 486.595H681.969",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M913.57 486.595H960.343",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M637.63 493.832L683.707 491.765",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M911.831 481.426L957.908 479.359",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M645.107 500.724L689.098 496.761",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M906.615 476.43L950.606 472.295",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M797.77 538.629C909.932 538.629 1000.86 515.333 1000.86 486.595C1000.86 457.858 909.932 434.562 797.77 434.562C685.608 434.562 594.684 457.858 594.684 486.595C594.684 515.333 685.608 538.629 797.77 538.629Z",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }))), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M557.727 341.805C595.86 326.345 614.24 282.9 598.781 244.767C583.321 206.634 539.875 188.253 501.742 203.713C463.609 219.173 445.229 262.619 460.689 300.752C476.148 338.885 519.594 357.265 557.727 341.805Z",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M593.095 289.949C602.566 254.963 581.881 218.923 546.894 209.453C511.908 199.982 475.869 220.667 466.398 255.653C456.927 290.639 477.612 326.679 512.598 336.149C547.585 345.62 583.624 324.935 593.095 289.949Z",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M584.695 285.911C591.934 255.56 573.198 225.088 542.847 217.849C512.497 210.61 482.024 229.346 474.785 259.696C467.546 290.047 486.282 320.52 516.633 327.759C546.983 334.998 577.456 316.262 584.695 285.911Z",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M576.738 280.491C580.978 254.538 563.375 230.062 537.422 225.823C511.469 221.584 486.994 239.187 482.755 265.139C478.516 291.092 496.118 315.568 522.071 319.807C548.024 324.046 572.499 306.444 576.738 280.491Z",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M548.487 306.666C567.208 296.312 573.99 272.743 563.636 254.023C553.282 235.302 529.713 228.52 510.993 238.874C492.272 249.228 485.49 272.797 495.844 291.517C506.198 310.237 529.767 317.02 548.487 306.666Z",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M541.079 300.368C556.33 294.105 563.615 276.664 557.352 261.414C551.088 246.164 533.648 238.878 518.398 245.142C503.147 251.405 495.862 268.845 502.125 284.096C508.388 299.346 525.829 306.632 541.079 300.368Z",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M549.916 277.582C552.555 266.445 545.666 255.276 534.528 252.637C523.39 249.998 512.222 256.887 509.583 268.024C506.943 279.162 513.833 290.331 524.97 292.97C536.108 295.609 547.276 288.72 549.916 277.582Z",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M530.984 242.397C547.021 242.89 559.603 255.719 560.343 271.756H609.439C608.699 228.581 573.912 193.794 530.984 193.301V242.397Z",
    fill: "url(#paint8_radial_2_12269)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M450.31 271.755H499.405C499.652 264.107 502.613 257.446 507.547 252.265L472.76 217.231C459.191 231.541 450.556 250.538 450.31 271.755Z",
    fill: "url(#paint9_radial_2_12269)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M528.024 352.184V303.088C512.481 302.101 499.899 289.519 499.405 273.729H450.31C450.803 316.657 485.343 351.197 528.024 352.184Z",
    fill: "url(#paint10_radial_2_12269)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M550.228 295.439C545.294 299.88 538.879 302.841 531.725 303.334V352.43C552.449 351.937 571.199 343.549 585.015 330.226L550.228 295.439Z",
    fill: "url(#paint11_radial_2_12269)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M449.569 272.742H472.76",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M586.988 272.742H609.933",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M450.803 286.805L473.5 282.611",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M586.002 262.874L608.7 258.926",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M454.503 300.127L476.214 292.232",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M583.534 253.252L605.245 245.357",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M460.424 312.957L480.408 301.361",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M579.34 244.124L599.324 232.775",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M468.319 324.305L486.083 309.502",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M573.666 235.982L591.183 221.179",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M478.188 334.174L492.99 316.657",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M566.511 229.074L581.314 211.311",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M489.783 342.316L501.132 322.332",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M558.369 223.4L569.965 203.416",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M502.365 348.236L510.26 326.525",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M549.24 219.205L557.135 197.495",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M515.935 351.69L519.882 328.993",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M539.619 216.492L543.813 193.794",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M529.751 352.924V329.98",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M529.751 215.752V192.561",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M543.813 351.69L539.619 328.993",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M519.882 216.492L515.935 193.794",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M557.136 348.236L549.241 326.525",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M510.26 219.205L502.365 197.495",
    stroke: "#00EAFC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }))), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M397.192 343.125C491.943 343.125 568.753 266.38 568.753 171.71C568.753 77.0404 491.943 0.29541 397.192 0.29541C302.441 0.29541 225.631 77.0404 225.631 171.71C225.631 266.38 302.441 343.125 397.192 343.125Z",
    fill: "url(#paint12_radial_2_12269)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M876.436 390.888C971.187 390.888 1048 314.143 1048 219.473C1048 124.804 971.187 48.0586 876.436 48.0586C781.686 48.0586 704.875 124.804 704.875 219.473C704.875 314.143 781.686 390.888 876.436 390.888Z",
    fill: "url(#paint13_radial_2_12269)"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2_12269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M713.377 472.87C798.092 472.87 866.767 405.713 866.767 322.87C866.767 240.027 798.092 172.87 713.377 172.87C628.663 172.87 559.988 240.027 559.988 322.87C559.988 405.713 628.663 472.87 713.377 472.87Z",
    fill: "url(#paint14_radial_2_12269)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M523.242 141.025C523.242 142.06 522.208 143.095 521.174 143.095C520.14 143.095 519.105 142.06 519.105 141.025C519.105 139.989 520.14 138.954 521.174 138.954C522.208 138.954 523.242 139.731 523.242 141.025Z",
    fill: "url(#paint15_radial_2_12269)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M602.879 202.361C602.879 203.655 601.845 204.949 600.294 204.949C599.001 204.949 597.708 203.913 597.708 202.361C597.708 201.066 598.742 199.772 600.294 199.772C601.845 200.031 602.879 201.066 602.879 202.361Z",
    fill: "url(#paint16_radial_2_12269)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M561.768 262.662C561.768 264.215 560.476 265.509 558.924 265.509C557.373 265.509 556.08 264.215 556.08 262.662C556.08 261.109 557.373 259.815 558.924 259.815C560.734 259.815 561.768 260.85 561.768 262.662Z",
    fill: "url(#paint17_radial_2_12269)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M596.674 308.729C596.674 310.282 595.381 311.576 593.83 311.576C592.278 311.576 590.985 310.282 590.985 308.729C590.985 307.176 592.278 305.882 593.83 305.882C595.381 305.882 596.674 307.176 596.674 308.729Z",
    fill: "url(#paint18_radial_2_12269)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M624.081 394.134C625.366 394.134 626.408 393.091 626.408 391.805C626.408 390.518 625.366 389.476 624.081 389.476C622.796 389.476 621.754 390.518 621.754 391.805C621.754 393.091 622.796 394.134 624.081 394.134Z",
    fill: "url(#paint19_radial_2_12269)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M626.667 464.528C626.667 466.081 625.374 467.375 623.823 467.375C622.271 467.375 620.979 466.081 620.979 464.528C620.979 462.976 622.271 461.682 623.823 461.682C625.374 461.682 626.667 462.976 626.667 464.528Z",
    fill: "url(#paint20_radial_2_12269)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M428.093 593.931C429.521 593.931 430.679 592.772 430.679 591.343C430.679 589.914 429.521 588.755 428.093 588.755C426.665 588.755 425.508 589.914 425.508 591.343C425.508 592.772 426.665 593.931 428.093 593.931Z",
    fill: "url(#paint21_radial_2_12269)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M360.091 670.536C360.091 673.124 358.023 675.195 355.437 675.195C352.852 675.195 350.783 673.124 350.783 670.536C350.783 667.948 352.852 665.878 355.437 665.878C358.023 665.878 360.091 667.948 360.091 670.536Z",
    fill: "url(#paint22_radial_2_12269)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M322.602 591.601C322.602 594.448 320.275 597.036 317.172 597.036C314.328 597.036 311.742 594.707 311.742 591.601C311.742 588.755 314.069 586.167 317.172 586.167C320.016 586.425 322.602 588.755 322.602 591.601Z",
    fill: "url(#paint23_radial_2_12269)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M266.493 519.395C266.493 520.948 265.201 521.983 263.908 521.983C262.357 521.983 261.322 520.689 261.322 519.395C261.322 518.101 262.615 516.807 263.908 516.807C265.459 516.807 266.493 517.842 266.493 519.395Z",
    fill: "url(#paint24_radial_2_12269)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M225.9 438.131C225.9 439.683 224.607 440.719 223.314 440.719C221.763 440.719 220.729 439.425 220.729 438.131C220.729 436.578 222.021 435.542 223.314 435.542C224.865 435.542 225.9 436.837 225.9 438.131Z",
    fill: "url(#paint25_radial_2_12269)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M237.017 433.214C237.017 434.766 235.724 435.802 234.431 435.802C232.88 435.802 231.846 434.508 231.846 433.214C231.846 431.661 233.139 430.625 234.431 430.625C235.983 430.625 237.017 431.661 237.017 433.214Z",
    fill: "url(#paint26_radial_2_12269)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M212.195 412.509C214.337 412.509 216.073 410.771 216.073 408.627C216.073 406.483 214.337 404.745 212.195 404.745C210.053 404.745 208.316 406.483 208.316 408.627C208.316 410.771 210.053 412.509 212.195 412.509Z",
    fill: "url(#paint27_radial_2_12269)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M211.679 377.83C211.679 379.9 209.869 381.712 207.8 381.712C205.732 381.712 203.922 379.9 203.922 377.83C203.922 375.759 205.732 373.948 207.8 373.948C209.869 373.948 211.679 375.759 211.679 377.83Z",
    fill: "url(#paint28_radial_2_12269)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M208.834 332.798C208.834 334.609 207.283 336.162 205.473 336.162C203.663 336.162 202.111 334.609 202.111 332.798C202.111 330.986 203.663 329.433 205.473 329.433C207.283 329.433 208.834 330.986 208.834 332.798Z",
    fill: "url(#paint29_radial_2_12269)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M223.831 304.847C225.545 304.847 226.934 303.457 226.934 301.741C226.934 300.026 225.545 298.636 223.831 298.636C222.118 298.636 220.729 300.026 220.729 301.741C220.729 303.457 222.118 304.847 223.831 304.847Z",
    fill: "url(#paint30_radial_2_12269)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M245.549 258.262C245.549 260.074 243.997 261.627 242.187 261.627C240.378 261.627 238.826 260.074 238.826 258.262C238.826 256.451 240.378 254.898 242.187 254.898C243.997 254.898 245.549 256.451 245.549 258.262Z",
    fill: "url(#paint31_radial_2_12269)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M276.835 190.197C276.835 192.785 274.767 195.114 271.922 195.114C269.337 195.114 267.01 193.043 267.01 190.197C267.01 187.609 269.078 185.279 271.922 185.279C274.767 185.538 276.835 187.609 276.835 190.197Z",
    fill: "url(#paint32_radial_2_12269)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M291.832 89.7811C291.832 92.8867 289.505 95.216 286.402 95.216C283.3 95.216 280.973 92.8867 280.973 89.7811C280.973 86.6754 283.3 84.3462 286.402 84.3462C289.505 84.3462 291.832 86.6754 291.832 89.7811Z",
    fill: "url(#paint33_radial_2_12269)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M203.146 159.658C203.146 162.246 201.078 164.316 198.492 164.316C195.906 164.316 193.838 162.246 193.838 159.658C193.838 157.07 195.906 155 198.492 155C201.078 155.258 203.146 157.329 203.146 159.658Z",
    fill: "url(#paint34_radial_2_12269)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M205.73 312.352C207.587 312.352 209.092 310.846 209.092 308.987C209.092 307.129 207.587 305.623 205.73 305.623C203.874 305.623 202.369 307.129 202.369 308.987C202.369 310.846 203.874 312.352 205.73 312.352Z",
    fill: "url(#paint35_radial_2_12269)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M161.776 405.521C161.776 407.85 159.966 409.662 157.639 409.662C155.312 409.662 153.502 407.85 153.502 405.521C153.502 403.192 155.312 401.38 157.639 401.38C159.707 401.38 161.776 403.192 161.776 405.521Z",
    fill: "url(#paint36_radial_2_12269)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M132.818 607.906C134.96 607.906 136.696 606.168 136.696 604.024C136.696 601.88 134.96 600.142 132.818 600.142C130.676 600.142 128.939 601.88 128.939 604.024C128.939 606.168 130.676 607.906 132.818 607.906Z",
    fill: "url(#paint37_radial_2_12269)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3746 622.399C36.3746 624.987 34.3061 627.057 31.7205 627.057C29.1349 627.057 27.0664 624.987 27.0664 622.399C27.0664 619.811 29.1349 617.74 31.7205 617.74C34.3061 617.74 36.3746 620.069 36.3746 622.399Z",
    fill: "url(#paint38_radial_2_12269)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M251.237 635.339C253.95 635.339 256.15 633.138 256.15 630.422C256.15 627.706 253.95 625.505 251.237 625.505C248.524 625.505 246.324 627.706 246.324 630.422C246.324 633.138 248.524 635.339 251.237 635.339Z",
    fill: "url(#paint39_radial_2_12269)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M300.624 659.149C303.337 659.149 305.536 656.947 305.536 654.232C305.536 651.516 303.337 649.314 300.624 649.314C297.91 649.314 295.711 651.516 295.711 654.232C295.711 656.947 297.91 659.149 300.624 659.149Z",
    fill: "url(#paint40_radial_2_12269)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M307.345 670.795C307.345 673.383 305.277 675.454 302.691 675.454C300.106 675.454 298.037 673.383 298.037 670.795C298.037 668.207 300.106 666.137 302.691 666.137C305.277 666.137 307.345 668.207 307.345 670.795Z",
    fill: "url(#paint41_radial_2_12269)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M555.563 653.455C555.563 656.043 553.495 658.114 550.909 658.114C548.323 658.114 546.255 656.043 546.255 653.455C546.255 650.867 548.323 648.797 550.909 648.797C553.495 648.797 555.563 650.867 555.563 653.455Z",
    fill: "url(#paint42_radial_2_12269)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M678.121 583.837C678.121 585.908 676.569 587.46 674.501 587.46C672.432 587.46 670.881 585.908 670.881 583.837C670.881 581.767 672.432 580.214 674.501 580.214C676.569 580.214 678.121 581.767 678.121 583.837Z",
    fill: "url(#paint43_radial_2_12269)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M514.452 392.84C514.452 395.169 512.642 397.24 510.057 397.24C507.471 397.24 505.661 395.428 505.661 392.84C505.661 390.511 507.471 388.44 510.057 388.44C512.642 388.44 514.452 390.511 514.452 392.84Z",
    fill: "url(#paint44_radial_2_12269)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M491.181 393.616C491.181 396.204 489.113 398.275 486.527 398.275C483.942 398.275 481.873 396.204 481.873 393.616C481.873 391.028 483.942 388.958 486.527 388.958C489.113 388.958 491.181 391.028 491.181 393.616Z",
    fill: "url(#paint45_radial_2_12269)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M450.846 373.689C450.846 376.277 448.778 378.347 446.192 378.347C443.607 378.347 441.538 376.277 441.538 373.689C441.538 371.101 443.607 369.03 446.192 369.03C448.778 369.03 450.846 371.101 450.846 373.689Z",
    fill: "url(#paint46_radial_2_12269)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M461.447 285.696C461.447 288.284 459.378 290.354 456.793 290.354C454.207 290.354 452.139 288.284 452.139 285.696C452.139 283.108 454.207 281.037 456.793 281.037C459.378 281.037 461.447 283.108 461.447 285.696Z",
    fill: "url(#paint47_radial_2_12269)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M481.615 186.056C481.615 187.091 480.581 188.126 479.547 188.126C478.513 188.126 477.479 187.091 477.479 186.056C477.479 185.021 478.513 183.985 479.547 183.985C480.581 183.985 481.615 185.021 481.615 186.056Z",
    fill: "url(#paint48_radial_2_12269)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M510.314 250.757C512.171 250.757 513.676 249.251 513.676 247.393C513.676 245.535 512.171 244.028 510.314 244.028C508.458 244.028 506.953 245.535 506.953 247.393C506.953 249.251 508.458 250.757 510.314 250.757Z",
    fill: "url(#paint49_radial_2_12269)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M542.376 303.812C544.375 303.812 545.996 302.19 545.996 300.189C545.996 298.188 544.375 296.565 542.376 296.565C540.377 296.565 538.756 298.188 538.756 300.189C538.756 302.19 540.377 303.812 542.376 303.812Z",
    fill: "url(#paint50_radial_2_12269)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M559.959 329.692C559.959 331.504 558.667 332.798 556.857 332.798C555.047 332.798 553.754 331.504 553.754 329.692C553.754 327.88 555.047 326.586 556.857 326.586C558.667 326.586 559.959 328.139 559.959 329.692Z",
    fill: "url(#paint51_radial_2_12269)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M442.314 164.058C443.313 164.058 444.124 163.247 444.124 162.246C444.124 161.246 443.313 160.435 442.314 160.435C441.314 160.435 440.504 161.246 440.504 162.246C440.504 163.247 441.314 164.058 442.314 164.058Z",
    fill: "url(#paint52_radial_2_12269)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M426.283 156.294C426.283 157.329 425.249 158.364 424.215 158.364C423.181 158.364 422.146 157.329 422.146 156.294C422.146 155.258 423.181 154.223 424.215 154.223C425.508 154.223 426.283 155.258 426.283 156.294Z",
    fill: "url(#paint53_radial_2_12269)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M439.987 78.3937C439.987 80.2054 438.694 81.4994 436.884 81.4994C435.074 81.4994 433.781 80.2054 433.781 78.3937C433.781 76.5821 435.074 75.2881 436.884 75.2881C438.694 75.2881 439.987 76.5821 439.987 78.3937Z",
    fill: "url(#paint54_radial_2_12269)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M479.029 45.0081C479.029 47.3373 477.219 49.4077 474.634 49.4077C472.048 49.4077 470.238 47.5961 470.238 45.0081C470.238 42.6788 472.048 40.6084 474.634 40.6084C477.219 40.6084 479.029 42.6788 479.029 45.0081Z",
    fill: "url(#paint55_radial_2_12269)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M535.136 71.4062C537.278 71.4062 539.015 69.6681 539.015 67.5241C539.015 65.3801 537.278 63.6421 535.136 63.6421C532.994 63.6421 531.258 65.3801 531.258 67.5241C531.258 69.6681 532.994 71.4062 535.136 71.4062Z",
    fill: "url(#paint56_radial_2_12269)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M514.969 76.841C514.969 78.9115 513.418 80.4643 511.349 80.4643C509.281 80.4643 507.729 78.9115 507.729 76.841C507.729 74.7706 509.281 73.2178 511.349 73.2178C513.418 73.2178 514.969 74.7706 514.969 76.841Z",
    fill: "url(#paint57_radial_2_12269)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M491.44 70.112C491.44 71.9236 489.889 73.4765 488.079 73.4765C486.269 73.4765 484.718 71.9236 484.718 70.112C484.718 68.3004 486.269 66.7476 488.079 66.7476C489.889 66.7476 491.44 68.3004 491.44 70.112Z",
    fill: "url(#paint58_radial_2_12269)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M505.661 42.4202C505.661 45.0082 503.593 46.8198 501.266 46.8198C498.68 46.8198 496.87 44.7494 496.87 42.4202C496.87 39.8321 498.939 38.0205 501.266 38.0205C503.593 38.0205 505.661 39.8321 505.661 42.4202Z",
    fill: "url(#paint59_radial_2_12269)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M505.92 24.5628C505.92 27.1508 503.851 29.2212 501.265 29.2212C498.68 29.2212 496.611 27.1508 496.611 24.5628C496.611 21.9747 498.68 19.9043 501.265 19.9043C503.851 19.9043 505.92 21.9747 505.92 24.5628Z",
    fill: "url(#paint60_radial_2_12269)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M391.118 86.6751C391.118 89.0043 389.308 91.0747 386.723 91.0747C384.396 91.0747 382.327 89.2631 382.327 86.6751C382.327 84.3458 384.137 82.2754 386.723 82.2754C389.308 82.2754 391.118 84.3458 391.118 86.6751Z",
    fill: "url(#paint61_radial_2_12269)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M373.02 100.133C375.591 100.133 377.674 98.0477 377.674 95.4749C377.674 92.9021 375.591 90.8164 373.02 90.8164C370.45 90.8164 368.366 92.9021 368.366 95.4749C368.366 98.0477 370.45 100.133 373.02 100.133Z",
    fill: "url(#paint62_radial_2_12269)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M368.883 63.3831C368.883 66.2299 366.556 68.3004 363.97 68.3004C361.385 68.3004 359.058 65.9711 359.058 63.3831C359.058 60.5362 361.385 58.4658 363.97 58.4658C366.556 58.4658 368.883 60.7951 368.883 63.3831Z",
    fill: "url(#paint63_radial_2_12269)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M343.803 50.1842C346.802 50.1842 349.233 47.7509 349.233 44.7493C349.233 41.7477 346.802 39.3145 343.803 39.3145C340.804 39.3145 338.373 41.7477 338.373 44.7493C338.373 47.7509 340.804 50.1842 343.803 50.1842Z",
    fill: "url(#paint64_radial_2_12269)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M310.965 69.5944C313.964 69.5944 316.395 67.1611 316.395 64.1595C316.395 61.1579 313.964 58.7246 310.965 58.7246C307.966 58.7246 305.535 61.1579 305.535 64.1595C305.535 67.1611 307.966 69.5944 310.965 69.5944Z",
    fill: "url(#paint65_radial_2_12269)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M323.636 124.461C326.777 124.461 329.324 121.911 329.324 118.767C329.324 115.622 326.777 113.073 323.636 113.073C320.494 113.073 317.947 115.622 317.947 118.767C317.947 121.911 320.494 124.461 323.636 124.461Z",
    fill: "url(#paint66_radial_2_12269)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M207.541 76.8411C207.541 79.4291 205.472 81.4995 202.886 81.4995C200.301 81.4995 198.232 79.4291 198.232 76.8411C198.232 74.253 200.301 72.1826 202.886 72.1826C205.472 72.1826 207.541 74.253 207.541 76.8411Z",
    fill: "url(#paint67_radial_2_12269)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M201.078 39.5735C201.078 42.1615 199.009 44.232 196.424 44.232C193.838 44.232 191.77 42.1615 191.77 39.5735C191.77 36.9855 193.838 34.915 196.424 34.915C199.009 34.915 201.078 36.9855 201.078 39.5735Z",
    fill: "url(#paint68_radial_2_12269)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M311.483 219.183C311.483 221.771 309.415 224.1 306.571 224.1C303.985 224.1 301.658 222.03 301.658 219.183C301.658 216.336 303.727 214.266 306.571 214.266C309.415 214.524 311.483 216.595 311.483 219.183Z",
    fill: "url(#paint69_radial_2_12269)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M319.497 259.556C321.925 259.556 323.893 257.586 323.893 255.157C323.893 252.727 321.925 250.757 319.497 250.757C317.07 250.757 315.102 252.727 315.102 255.157C315.102 257.586 317.07 259.556 319.497 259.556Z",
    fill: "url(#paint70_radial_2_12269)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M321.567 315.458C321.567 317.787 319.757 319.599 317.43 319.599C315.103 319.599 313.293 317.787 313.293 315.458C313.293 313.129 315.103 311.317 317.43 311.317C319.757 311.317 321.567 313.129 321.567 315.458Z",
    fill: "url(#paint71_radial_2_12269)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M382.586 231.605C382.586 233.934 380.777 235.746 378.449 235.746C376.122 235.746 374.312 233.934 374.312 231.605C374.312 229.276 376.122 227.464 378.449 227.464C380.777 227.206 382.586 229.276 382.586 231.605Z",
    fill: "url(#paint72_radial_2_12269)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M449.037 230.829C450.893 230.829 452.398 229.323 452.398 227.465C452.398 225.606 450.893 224.1 449.037 224.1C447.181 224.1 445.676 225.606 445.676 227.465C445.676 229.323 447.181 230.829 449.037 230.829Z",
    fill: "url(#paint73_radial_2_12269)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M521.692 272.238C523.691 272.238 525.312 270.616 525.312 268.614C525.312 266.613 523.691 264.991 521.692 264.991C519.693 264.991 518.072 266.613 518.072 268.614C518.072 270.616 519.693 272.238 521.692 272.238Z",
    fill: "url(#paint74_radial_2_12269)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M570.043 303.553C570.043 305.365 568.75 306.659 566.941 306.659C565.131 306.659 563.838 305.365 563.838 303.553C563.838 301.741 565.131 300.447 566.941 300.447C568.75 300.447 570.043 301.741 570.043 303.553Z",
    fill: "url(#paint75_radial_2_12269)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M583.746 371.101C583.746 372.654 582.712 373.689 581.161 373.689C579.609 373.689 578.575 372.654 578.575 371.101C578.575 369.548 579.609 368.513 581.161 368.513C582.712 368.513 583.746 369.807 583.746 371.101Z",
    fill: "url(#paint76_radial_2_12269)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M581.419 423.638C582.99 423.638 584.263 422.363 584.263 420.791C584.263 419.219 582.99 417.944 581.419 417.944C579.849 417.944 578.575 419.219 578.575 420.791C578.575 422.363 579.849 423.638 581.419 423.638Z",
    fill: "url(#paint77_radial_2_12269)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M544.703 449.259C546.845 449.259 548.581 447.521 548.581 445.377C548.581 443.233 546.845 441.495 544.703 441.495C542.561 441.495 540.824 443.233 540.824 445.377C540.824 447.521 542.561 449.259 544.703 449.259Z",
    fill: "url(#paint78_radial_2_12269)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M491.44 442.531C491.44 445.119 489.372 447.189 486.786 447.189C484.2 447.189 482.132 445.119 482.132 442.531C482.132 439.943 484.2 437.872 486.786 437.872C489.372 437.872 491.44 439.943 491.44 442.531Z",
    fill: "url(#paint79_radial_2_12269)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M474.116 460.905C476.544 460.905 478.512 458.935 478.512 456.506C478.512 454.076 476.544 452.106 474.116 452.106C471.689 452.106 469.721 454.076 469.721 456.506C469.721 458.935 471.689 460.905 474.116 460.905Z",
    fill: "url(#paint80_radial_2_12269)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M551.684 402.416C551.684 404.228 550.133 405.781 548.323 405.781C546.513 405.781 544.962 404.228 544.962 402.416C544.962 400.605 546.513 399.052 548.323 399.052C550.392 399.052 551.684 400.605 551.684 402.416Z",
    fill: "url(#paint81_radial_2_12269)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M555.305 468.411C555.305 470.481 553.495 472.293 551.426 472.293C549.358 472.293 547.548 470.481 547.548 468.411C547.548 466.34 549.358 464.529 551.426 464.529C553.495 464.27 555.305 466.081 555.305 468.411Z",
    fill: "url(#paint82_radial_2_12269)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M554.787 498.432C554.787 500.761 552.977 502.573 550.65 502.573C548.323 502.573 546.513 500.761 546.513 498.432C546.513 496.103 548.323 494.291 550.65 494.291C552.977 494.291 554.787 496.103 554.787 498.432Z",
    fill: "url(#paint83_radial_2_12269)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M605.983 518.36C605.983 520.171 604.69 521.465 602.88 521.465C601.07 521.465 599.777 520.171 599.777 518.36C599.777 516.548 601.07 515.254 602.88 515.254C604.69 515.254 605.983 516.548 605.983 518.36Z",
    fill: "url(#paint84_radial_2_12269)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M488.337 554.075C490.051 554.075 491.44 552.684 491.44 550.969C491.44 549.254 490.051 547.863 488.337 547.863C486.624 547.863 485.234 549.254 485.234 550.969C485.234 552.684 486.624 554.075 488.337 554.075Z",
    fill: "url(#paint85_radial_2_12269)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M464.291 558.216C464.291 559.768 463.257 560.804 461.706 560.804C460.154 560.804 459.12 559.768 459.12 558.216C459.12 556.663 460.154 555.627 461.706 555.627C462.999 555.886 464.291 556.921 464.291 558.216Z",
    fill: "url(#paint86_radial_2_12269)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M451.88 578.92C451.88 580.214 450.846 581.508 449.295 581.508C448.002 581.508 446.709 580.473 446.709 578.92C446.709 577.367 447.743 576.332 449.295 576.332C450.846 576.591 451.88 577.626 451.88 578.92Z",
    fill: "url(#paint87_radial_2_12269)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M407.409 575.555C407.409 577.108 406.374 578.143 404.823 578.143C403.272 578.143 402.237 577.108 402.237 575.555C402.237 574.003 403.272 572.967 404.823 572.967C406.374 572.967 407.409 574.003 407.409 575.555Z",
    fill: "url(#paint88_radial_2_12269)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M324.151 547.863C324.151 549.934 322.341 551.745 320.273 551.745C318.204 551.745 316.395 549.934 316.395 547.863C316.395 545.793 318.204 543.981 320.273 543.981C322.6 544.24 324.151 545.793 324.151 547.863Z",
    fill: "url(#paint89_radial_2_12269)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M175.222 505.161C175.222 507.231 173.671 508.784 171.602 508.784C169.534 508.784 167.982 507.231 167.982 505.161C167.982 503.09 169.534 501.538 171.602 501.538C173.671 501.796 175.222 503.349 175.222 505.161Z",
    fill: "url(#paint90_radial_2_12269)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M134.11 533.629C136.394 533.629 138.247 531.775 138.247 529.488C138.247 527.202 136.394 525.348 134.11 525.348C131.825 525.348 129.973 527.202 129.973 529.488C129.973 531.775 131.825 533.629 134.11 533.629Z",
    fill: "url(#paint91_radial_2_12269)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M104.892 507.231C104.892 509.819 102.824 511.89 100.238 511.89C97.6525 511.89 95.584 509.819 95.584 507.231C95.584 504.643 97.6525 502.573 100.238 502.573C102.824 502.573 104.892 504.643 104.892 507.231Z",
    fill: "url(#paint92_radial_2_12269)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M551.426 571.673C553.568 571.673 555.305 569.935 555.305 567.791C555.305 565.647 553.568 563.909 551.426 563.909C549.284 563.909 547.548 565.647 547.548 567.791C547.548 569.935 549.284 571.673 551.426 571.673Z",
    fill: "url(#paint93_radial_2_12269)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M652.781 538.805C652.781 540.358 651.488 541.652 649.937 541.652C648.386 541.652 647.093 540.358 647.093 538.805C647.093 537.253 648.386 535.958 649.937 535.958C651.488 535.958 652.781 537.253 652.781 538.805Z",
    fill: "url(#paint94_radial_2_12269)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M696.219 514.737C696.219 516.807 694.668 518.36 692.599 518.36C690.531 518.36 688.979 516.807 688.979 514.737C688.979 512.666 690.531 511.113 692.599 511.113C694.668 511.113 696.219 512.666 696.219 514.737Z",
    fill: "url(#paint95_radial_2_12269)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M629.51 566.756C631.081 566.756 632.354 565.482 632.354 563.909C632.354 562.337 631.081 561.062 629.51 561.062C627.939 561.062 626.666 562.337 626.666 563.909C626.666 565.482 627.939 566.756 629.51 566.756Z",
    fill: "url(#paint96_radial_2_12269)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M494.802 627.317C494.802 629.387 492.992 631.199 490.923 631.199C488.855 631.199 487.045 629.387 487.045 627.317C487.045 625.246 488.855 623.435 490.923 623.435C492.992 623.435 494.802 625.246 494.802 627.317Z",
    fill: "url(#paint97_radial_2_12269)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M448.52 674.159C448.52 676.747 446.451 678.559 444.124 678.559C441.538 678.559 439.729 676.489 439.729 674.159C439.729 671.571 441.797 669.76 444.124 669.76C446.451 669.76 448.52 671.571 448.52 674.159Z",
    fill: "url(#paint98_radial_2_12269)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M220.727 679.336C220.727 681.665 218.917 683.476 216.59 683.476C214.263 683.476 212.453 681.665 212.453 679.336C212.453 677.006 214.263 675.195 216.59 675.195C218.917 675.454 220.727 677.265 220.727 679.336Z",
    fill: "url(#paint99_radial_2_12269)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M339.406 626.799C339.406 629.128 337.338 631.198 335.011 631.198C332.684 631.198 330.615 629.128 330.615 626.799C330.615 624.469 332.684 622.399 335.011 622.399C337.596 622.399 339.406 624.469 339.406 626.799Z",
    fill: "url(#paint100_radial_2_12269)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M369.659 617.741C371.801 617.741 373.537 616.003 373.537 613.859C373.537 611.715 371.801 609.977 369.659 609.977C367.517 609.977 365.78 611.715 365.78 613.859C365.78 616.003 367.517 617.741 369.659 617.741Z",
    fill: "url(#paint101_radial_2_12269)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M422.146 550.451C423.717 550.451 424.99 549.177 424.99 547.605C424.99 546.032 423.717 544.758 422.146 544.758C420.575 544.758 419.302 546.032 419.302 547.605C419.302 549.177 420.575 550.451 422.146 550.451Z",
    fill: "url(#paint102_radial_2_12269)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M477.737 500.243C477.737 502.314 476.185 503.867 474.117 503.867C472.048 503.867 470.497 502.314 470.497 500.243C470.497 498.173 472.048 496.62 474.117 496.62C476.185 496.62 477.737 498.173 477.737 500.243Z",
    fill: "url(#paint103_radial_2_12269)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M511.091 465.305C511.091 467.634 509.281 469.187 507.212 469.187C504.885 469.187 503.334 467.376 503.334 465.305C503.334 462.976 505.144 461.423 507.212 461.423C509.539 461.164 511.091 462.976 511.091 465.305Z",
    fill: "url(#paint104_radial_2_12269)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M592.278 348.585C593.992 348.585 595.381 347.194 595.381 345.479C595.381 343.764 593.992 342.374 592.278 342.374C590.565 342.374 589.176 343.764 589.176 345.479C589.176 347.194 590.565 348.585 592.278 348.585Z",
    fill: "url(#paint105_radial_2_12269)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M628.217 362.819C628.217 364.63 626.924 365.924 625.114 365.924C623.305 365.924 622.012 364.63 622.012 362.819C622.012 361.007 623.305 359.713 625.114 359.713C626.924 359.713 628.217 361.007 628.217 362.819Z",
    fill: "url(#paint106_radial_2_12269)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M582.453 210.124C582.453 211.677 581.16 212.971 579.609 212.971C578.057 212.971 576.765 211.677 576.765 210.124C576.765 208.571 578.057 207.277 579.609 207.277C581.16 207.277 582.453 208.571 582.453 210.124Z",
    fill: "url(#paint107_radial_2_12269)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M558.924 206.501C560.495 206.501 561.768 205.227 561.768 203.654C561.768 202.082 560.495 200.808 558.924 200.808C557.353 200.808 556.08 202.082 556.08 203.654C556.08 205.227 557.353 206.501 558.924 206.501Z",
    fill: "url(#paint108_radial_2_12269)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M525.311 191.491C525.311 193.044 524.019 194.338 522.467 194.338C520.916 194.338 519.623 193.044 519.623 191.491C519.623 189.938 520.916 188.644 522.467 188.644C524.019 188.644 525.311 189.938 525.311 191.491Z",
    fill: "url(#paint109_radial_2_12269)"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_2_12269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.485 459.989C300.641 493.567 389.679 459.233 423.357 383.304C457.035 307.374 422.601 218.6 346.444 185.022C270.288 151.444 181.25 185.777 147.572 261.707C113.894 337.637 148.329 426.411 224.485 459.989Z",
    fill: "url(#paint110_radial_2_12269)"
  }))), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M362 481.001C459.754 481.001 539 401.755 539 304.001C539 206.247 459.754 127.001 362 127.001C264.246 127.001 185 206.247 185 304.001C185 401.755 264.246 481.001 362 481.001Z",
    fill: "url(#paint111_linear_2_12269)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.89
  }, _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M470.643 302.373C477.478 308.856 484.123 315.15 490.903 321.606C490.012 322.201 489.499 322.579 488.958 322.876C447.519 346.729 406.053 370.555 364.614 394.435C363.453 395.111 362.615 395.219 361.427 394.516C319.907 370.528 278.333 346.567 236.785 322.579C236.353 322.336 235.921 322.066 234.895 321.417C236.569 319.931 238.109 318.689 239.514 317.311C243.701 313.151 247.888 308.964 251.967 304.696C253.129 303.48 253.966 303.345 255.479 304.209C290.597 324.254 325.769 344.217 360.886 364.261C362.588 365.233 363.75 365.206 365.425 364.234C400.002 343.839 434.634 323.524 469.265 303.183C469.887 302.805 470.535 302.454 470.643 302.373Z",
    fill: "white"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M268.148 258.448C274.388 262.068 280.304 265.472 286.247 268.93C311.261 283.436 336.303 297.969 361.291 312.53C362.804 313.421 363.884 313.475 365.451 312.557C395.22 295.079 425.07 277.682 454.893 260.258C455.758 259.745 456.649 259.259 457.865 258.583C457.865 261.15 457.865 263.392 457.865 265.661C457.865 272.684 457.838 279.708 457.892 286.705C457.919 288.055 457.568 288.812 456.379 289.514C425.772 307.181 395.166 324.902 364.586 342.65C363.533 343.244 362.831 343.217 361.804 342.623C331.143 325.037 300.456 307.478 269.795 289.865C269.093 289.46 268.229 288.514 268.229 287.839C268.121 278.168 268.148 268.497 268.148 258.448Z",
    fill: "white"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M304.373 257.476C330.333 242.429 356.05 227.518 382.091 212.417C382.173 213.471 382.281 214.227 382.308 214.983C382.47 221.034 382.686 227.085 382.74 233.164C382.74 233.92 382.173 235 381.524 235.379C362.642 246.4 343.732 257.341 324.822 268.254C324.228 268.578 323.175 268.741 322.661 268.443C316.583 264.878 310.613 261.231 304.373 257.476Z",
    fill: "white"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M394.599 251.046C394.599 258.475 394.626 265.337 394.545 272.198C394.545 272.819 393.897 273.657 393.302 274.008C383.55 279.708 373.771 285.327 363.965 290.946C363.479 291.243 362.588 291.432 362.182 291.189C356.05 287.677 349.972 284.057 343.543 280.275C360.589 270.523 377.337 260.933 394.599 251.046Z",
    fill: "white"
  }))), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M363.115 467.067C453.207 467.067 526.241 394.033 526.241 303.941C526.241 213.849 453.207 140.814 363.115 140.814C273.022 140.814 199.988 213.849 199.988 303.941C199.988 394.033 273.022 467.067 363.115 467.067Z",
    stroke: "url(#paint112_linear_2_12269)",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M961.143 133.685C961.143 134.719 960.109 135.753 959.074 135.753C958.04 135.753 957.006 134.719 957.006 133.685C957.006 132.651 958.04 131.616 959.074 131.616C960.109 131.616 961.143 132.392 961.143 133.685Z",
    fill: "url(#paint113_radial_2_12269)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M1040.76 194.969C1040.76 196.262 1039.73 197.554 1038.17 197.554C1036.88 197.554 1035.59 196.52 1035.59 194.969C1035.59 193.676 1036.62 192.383 1038.17 192.383C1039.73 192.641 1040.76 193.676 1040.76 194.969Z",
    fill: "url(#paint114_radial_2_12269)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M999.659 255.217C999.659 256.769 998.366 258.062 996.815 258.062C995.264 258.062 993.972 256.769 993.972 255.217C993.972 253.666 995.264 252.373 996.815 252.373C998.625 252.373 999.659 253.407 999.659 255.217Z",
    fill: "url(#paint115_radial_2_12269)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M1034.56 301.245C1034.56 302.797 1033.26 304.09 1031.71 304.09C1030.16 304.09 1028.87 302.797 1028.87 301.245C1028.87 299.694 1030.16 298.401 1031.71 298.401C1033.26 298.401 1034.56 299.694 1034.56 301.245Z",
    fill: "url(#paint116_radial_2_12269)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M1061.96 386.577C1063.24 386.577 1064.28 385.535 1064.28 384.25C1064.28 382.964 1063.24 381.922 1061.96 381.922C1060.67 381.922 1059.63 382.964 1059.63 384.25C1059.63 385.535 1060.67 386.577 1061.96 386.577Z",
    fill: "url(#paint117_radial_2_12269)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M1064.54 456.911C1064.54 458.462 1063.25 459.755 1061.7 459.755C1060.15 459.755 1058.86 458.462 1058.86 456.911C1058.86 455.359 1060.15 454.066 1061.7 454.066C1063.25 454.066 1064.54 455.359 1064.54 456.911Z",
    fill: "url(#paint118_radial_2_12269)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M866.015 586.201C867.442 586.201 868.6 585.043 868.6 583.615C868.6 582.187 867.442 581.029 866.015 581.029C864.587 581.029 863.43 582.187 863.43 583.615C863.43 585.043 864.587 586.201 866.015 586.201Z",
    fill: "url(#paint119_radial_2_12269)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M798.029 662.74C798.029 665.326 795.961 667.395 793.376 667.395C790.791 667.395 788.723 665.326 788.723 662.74C788.723 660.155 790.791 658.086 793.376 658.086C795.961 658.086 798.029 660.155 798.029 662.74Z",
    fill: "url(#paint120_radial_2_12269)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M760.545 583.874C760.545 586.718 758.219 589.304 755.117 589.304C752.273 589.304 749.688 586.976 749.688 583.874C749.688 581.029 752.015 578.443 755.117 578.443C757.96 578.702 760.545 581.029 760.545 583.874Z",
    fill: "url(#paint121_radial_2_12269)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M704.451 511.729C704.451 513.281 703.159 514.315 701.866 514.315C700.315 514.315 699.281 513.022 699.281 511.729C699.281 510.436 700.574 509.144 701.866 509.144C703.417 509.144 704.451 510.178 704.451 511.729Z",
    fill: "url(#paint122_radial_2_12269)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M663.866 430.536C663.866 432.087 662.574 433.121 661.281 433.121C659.73 433.121 658.696 431.828 658.696 430.536C658.696 428.984 659.989 427.95 661.281 427.95C662.832 427.95 663.866 429.243 663.866 430.536Z",
    fill: "url(#paint123_radial_2_12269)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M674.982 425.622C674.982 427.174 673.689 428.208 672.397 428.208C670.846 428.208 669.812 426.915 669.812 425.622C669.812 424.071 671.104 423.037 672.397 423.037C673.948 423.037 674.982 424.071 674.982 425.622Z",
    fill: "url(#paint124_radial_2_12269)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M650.166 404.936C652.307 404.936 654.043 403.2 654.043 401.057C654.043 398.915 652.307 397.179 650.166 397.179C648.024 397.179 646.288 398.915 646.288 401.057C646.288 403.2 648.024 404.936 650.166 404.936Z",
    fill: "url(#paint125_radial_2_12269)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M649.649 370.286C649.649 372.355 647.839 374.165 645.771 374.165C643.703 374.165 641.894 372.355 641.894 370.286C641.894 368.218 643.703 366.408 645.771 366.408C647.839 366.408 649.649 368.218 649.649 370.286Z",
    fill: "url(#paint126_radial_2_12269)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M646.806 325.293C646.806 327.103 645.255 328.655 643.445 328.655C641.636 328.655 640.085 327.103 640.085 325.293C640.085 323.483 641.636 321.932 643.445 321.932C645.255 321.932 646.806 323.483 646.806 325.293Z",
    fill: "url(#paint127_radial_2_12269)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M661.798 297.367C663.512 297.367 664.9 295.977 664.9 294.264C664.9 292.55 663.512 291.161 661.798 291.161C660.085 291.161 658.696 292.55 658.696 294.264C658.696 295.977 660.085 297.367 661.798 297.367Z",
    fill: "url(#paint128_radial_2_12269)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M683.512 250.822C683.512 252.633 681.961 254.184 680.152 254.184C678.342 254.184 676.791 252.633 676.791 250.822C676.791 249.012 678.342 247.461 680.152 247.461C681.961 247.461 683.512 249.012 683.512 250.822Z",
    fill: "url(#paint129_radial_2_12269)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M714.79 182.815C714.79 185.401 712.722 187.728 709.878 187.728C707.293 187.728 704.967 185.66 704.967 182.815C704.967 180.23 707.035 177.902 709.878 177.902C712.722 178.161 714.79 180.23 714.79 182.815Z",
    fill: "url(#paint130_radial_2_12269)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M729.785 82.4859C729.785 85.5888 727.458 87.916 724.356 87.916C721.254 87.916 718.928 85.5888 718.928 82.4859C718.928 79.3829 721.254 77.0557 724.356 77.0557C727.458 77.0557 729.785 79.3829 729.785 82.4859Z",
    fill: "url(#paint131_radial_2_12269)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M641.119 152.303C641.119 154.889 639.051 156.957 636.466 156.957C633.881 156.957 631.812 154.889 631.812 152.303C631.812 149.717 633.881 147.648 636.466 147.648C639.051 147.907 641.119 149.976 641.119 152.303Z",
    fill: "url(#paint132_radial_2_12269)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M643.703 304.865C645.559 304.865 647.064 303.36 647.064 301.504C647.064 299.647 645.559 298.142 643.703 298.142C641.847 298.142 640.343 299.647 640.343 301.504C640.343 303.36 641.847 304.865 643.703 304.865Z",
    fill: "url(#paint133_radial_2_12269)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M599.758 397.954C599.758 400.281 597.949 402.091 595.622 402.091C593.296 402.091 591.486 400.281 591.486 397.954C591.486 395.627 593.296 393.817 595.622 393.817C597.69 393.817 599.758 395.627 599.758 397.954Z",
    fill: "url(#paint134_radial_2_12269)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M570.806 600.164C572.948 600.164 574.684 598.428 574.684 596.285C574.684 594.143 572.948 592.407 570.806 592.407C568.665 592.407 566.929 594.143 566.929 596.285C566.929 598.428 568.665 600.164 570.806 600.164Z",
    fill: "url(#paint135_radial_2_12269)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M474.385 614.645C474.385 617.231 472.317 619.299 469.732 619.299C467.147 619.299 465.079 617.231 465.079 614.645C465.079 612.059 467.147 609.99 469.732 609.99C472.317 609.99 474.385 612.317 474.385 614.645Z",
    fill: "url(#paint136_radial_2_12269)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M689.199 627.574C691.911 627.574 694.11 625.374 694.11 622.661C694.11 619.948 691.911 617.748 689.199 617.748C686.486 617.748 684.287 619.948 684.287 622.661C684.287 625.374 686.486 627.574 689.199 627.574Z",
    fill: "url(#paint137_radial_2_12269)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M738.574 651.363C741.286 651.363 743.485 649.164 743.485 646.45C743.485 643.737 741.286 641.537 738.574 641.537C735.861 641.537 733.662 643.737 733.662 646.45C733.662 649.164 735.861 651.363 738.574 651.363Z",
    fill: "url(#paint138_radial_2_12269)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M745.293 662.999C745.293 665.585 743.225 667.654 740.64 667.654C738.055 667.654 735.987 665.585 735.987 662.999C735.987 660.413 738.055 658.345 740.64 658.345C743.225 658.345 745.293 660.413 745.293 662.999Z",
    fill: "url(#paint139_radial_2_12269)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M993.454 645.674C993.454 648.26 991.386 650.328 988.801 650.328C986.216 650.328 984.148 648.26 984.148 645.674C984.148 643.088 986.216 641.02 988.801 641.02C991.386 641.02 993.454 643.088 993.454 645.674Z",
    fill: "url(#paint140_radial_2_12269)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M1115.98 576.116C1115.98 578.185 1114.43 579.736 1112.37 579.736C1110.3 579.736 1108.75 578.185 1108.75 576.116C1108.75 574.048 1110.3 572.496 1112.37 572.496C1114.43 572.496 1115.98 574.048 1115.98 576.116Z",
    fill: "url(#paint141_radial_2_12269)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M952.353 385.284C952.353 387.611 950.544 389.68 947.959 389.68C945.374 389.68 943.564 387.87 943.564 385.284C943.564 382.957 945.374 380.888 947.959 380.888C950.544 380.888 952.353 382.957 952.353 385.284Z",
    fill: "url(#paint142_radial_2_12269)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M929.088 386.06C929.088 388.645 927.02 390.714 924.435 390.714C921.85 390.714 919.782 388.645 919.782 386.06C919.782 383.474 921.85 381.405 924.435 381.405C927.02 381.405 929.088 383.474 929.088 386.06Z",
    fill: "url(#paint143_radial_2_12269)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M888.761 366.149C888.761 368.734 886.693 370.803 884.108 370.803C881.523 370.803 879.455 368.734 879.455 366.149C879.455 363.563 881.523 361.494 884.108 361.494C886.693 361.494 888.761 363.563 888.761 366.149Z",
    fill: "url(#paint144_radial_2_12269)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M899.361 278.232C899.361 280.817 897.293 282.886 894.708 282.886C892.123 282.886 890.055 280.817 890.055 278.232C890.055 275.646 892.123 273.577 894.708 273.577C897.293 273.577 899.361 275.646 899.361 278.232Z",
    fill: "url(#paint145_radial_2_12269)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M919.525 178.678C919.525 179.712 918.49 180.747 917.456 180.747C916.422 180.747 915.388 179.712 915.388 178.678C915.388 177.644 916.422 176.609 917.456 176.609C918.49 176.609 919.525 177.644 919.525 178.678Z",
    fill: "url(#paint146_radial_2_12269)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M948.217 243.323C950.073 243.323 951.577 241.818 951.577 239.962C951.577 238.105 950.073 236.6 948.217 236.6C946.361 236.6 944.856 238.105 944.856 239.962C944.856 241.818 946.361 243.323 948.217 243.323Z",
    fill: "url(#paint147_radial_2_12269)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M980.271 296.332C982.27 296.332 983.89 294.711 983.89 292.712C983.89 290.713 982.27 289.092 980.271 289.092C978.273 289.092 976.652 290.713 976.652 292.712C976.652 294.711 978.273 296.332 980.271 296.332Z",
    fill: "url(#paint148_radial_2_12269)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M997.851 322.19C997.851 324 996.558 325.293 994.749 325.293C992.939 325.293 991.646 324 991.646 322.19C991.646 320.38 992.939 319.087 994.749 319.087C996.558 319.087 997.851 320.639 997.851 322.19Z",
    fill: "url(#paint149_radial_2_12269)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M880.233 156.699C881.232 156.699 882.043 155.888 882.043 154.889C882.043 153.889 881.232 153.079 880.233 153.079C879.233 153.079 878.423 153.889 878.423 154.889C878.423 155.888 879.233 156.699 880.233 156.699Z",
    fill: "url(#paint150_radial_2_12269)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M864.205 148.942C864.205 149.976 863.171 151.01 862.137 151.01C861.103 151.01 860.068 149.976 860.068 148.942C860.068 147.907 861.103 146.873 862.137 146.873C863.43 146.873 864.205 147.907 864.205 148.942Z",
    fill: "url(#paint151_radial_2_12269)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M877.905 71.1088C877.905 72.9189 876.613 74.2118 874.803 74.2118C872.994 74.2118 871.701 72.9189 871.701 71.1088C871.701 69.2988 872.994 68.0059 874.803 68.0059C876.613 68.0059 877.905 69.2988 877.905 71.1088Z",
    fill: "url(#paint152_radial_2_12269)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M916.939 37.7518C916.939 40.0791 915.13 42.1477 912.545 42.1477C909.96 42.1477 908.15 40.3376 908.15 37.7518C908.15 35.4246 909.96 33.356 912.545 33.356C915.13 33.356 916.939 35.4246 916.939 37.7518Z",
    fill: "url(#paint153_radial_2_12269)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M973.033 64.127C975.174 64.127 976.91 62.3905 976.91 60.2483C976.91 58.1062 975.174 56.3696 973.033 56.3696C970.891 56.3696 969.155 58.1062 969.155 60.2483C969.155 62.3905 970.891 64.127 973.033 64.127Z",
    fill: "url(#paint154_radial_2_12269)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M952.871 69.5576C952.871 71.6263 951.32 73.1777 949.252 73.1777C947.184 73.1777 945.633 71.6263 945.633 69.5576C945.633 67.489 947.184 65.9375 949.252 65.9375C951.32 65.9375 952.871 67.489 952.871 69.5576Z",
    fill: "url(#paint155_radial_2_12269)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M929.346 62.8342C929.346 64.6443 927.795 66.1957 925.986 66.1957C924.176 66.1957 922.625 64.6443 922.625 62.8342C922.625 61.0241 924.176 59.4727 925.986 59.4727C927.795 59.4727 929.346 61.0241 929.346 62.8342Z",
    fill: "url(#paint156_radial_2_12269)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M943.564 35.1659C943.564 37.7517 941.496 39.5618 939.17 39.5618C936.585 39.5618 934.775 37.4931 934.775 35.1659C934.775 32.5801 936.843 30.77 939.17 30.77C941.496 30.77 943.564 32.5801 943.564 35.1659Z",
    fill: "url(#paint157_radial_2_12269)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M943.824 17.3239C943.824 19.9097 941.756 21.9783 939.171 21.9783C936.586 21.9783 934.518 19.9097 934.518 17.3239C934.518 14.7381 936.586 12.6694 939.171 12.6694C941.756 12.6694 943.824 14.7381 943.824 17.3239Z",
    fill: "url(#paint158_radial_2_12269)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M829.048 79.3832C829.048 81.7104 827.238 83.779 824.653 83.779C822.327 83.779 820.259 81.969 820.259 79.3832C820.259 77.0559 822.068 74.9873 824.653 74.9873C827.238 74.9873 829.048 77.0559 829.048 79.3832Z",
    fill: "url(#paint159_radial_2_12269)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M810.954 92.8294C813.524 92.8294 815.607 90.7455 815.607 88.175C815.607 85.6044 813.524 83.5205 810.954 83.5205C808.384 83.5205 806.301 85.6044 806.301 88.175C806.301 90.7455 808.384 92.8294 810.954 92.8294Z",
    fill: "url(#paint160_radial_2_12269)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M806.817 56.1113C806.817 58.9557 804.491 61.0243 801.906 61.0243C799.321 61.0243 796.994 58.6971 796.994 56.1113C796.994 53.2669 799.321 51.1982 801.906 51.1982C804.491 51.1982 806.817 53.5255 806.817 56.1113Z",
    fill: "url(#paint161_radial_2_12269)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M781.743 42.9234C784.741 42.9234 787.172 40.4922 787.172 37.4932C787.172 34.4942 784.741 32.063 781.743 32.063C778.745 32.063 776.314 34.4942 776.314 37.4932C776.314 40.4922 778.745 42.9234 781.743 42.9234Z",
    fill: "url(#paint162_radial_2_12269)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M748.913 62.3169C751.911 62.3169 754.341 59.8857 754.341 56.8867C754.341 53.8877 751.911 51.4565 748.913 51.4565C745.915 51.4565 743.484 53.8877 743.484 56.8867C743.484 59.8857 745.915 62.3169 748.913 62.3169Z",
    fill: "url(#paint163_radial_2_12269)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M761.58 117.136C764.72 117.136 767.267 114.589 767.267 111.447C767.267 108.305 764.72 105.758 761.58 105.758C758.439 105.758 755.893 108.305 755.893 111.447C755.893 114.589 758.439 117.136 761.58 117.136Z",
    fill: "url(#paint164_radial_2_12269)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M645.513 69.5573C645.513 72.1431 643.445 74.2117 640.86 74.2117C638.275 74.2117 636.207 72.1431 636.207 69.5573C636.207 66.9715 638.275 64.9028 640.86 64.9028C643.445 64.9028 645.513 66.9715 645.513 69.5573Z",
    fill: "url(#paint165_radial_2_12269)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M639.05 32.3214C639.05 34.9072 636.982 36.9759 634.397 36.9759C631.812 36.9759 629.744 34.9072 629.744 32.3214C629.744 29.7356 631.812 27.667 634.397 27.667C636.982 27.667 639.05 29.7356 639.05 32.3214Z",
    fill: "url(#paint166_radial_2_12269)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M749.43 211.776C749.43 214.362 747.362 216.689 744.519 216.689C741.934 216.689 739.607 214.621 739.607 211.776C739.607 208.932 741.675 206.863 744.519 206.863C747.362 207.122 749.43 209.191 749.43 211.776Z",
    fill: "url(#paint167_radial_2_12269)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M757.443 252.115C759.87 252.115 761.838 250.147 761.838 247.719C761.838 245.291 759.87 243.323 757.443 243.323C755.016 243.323 753.049 245.291 753.049 247.719C753.049 250.147 755.016 252.115 757.443 252.115Z",
    fill: "url(#paint168_radial_2_12269)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M759.511 307.968C759.511 310.296 757.702 312.106 755.375 312.106C753.049 312.106 751.239 310.296 751.239 307.968C751.239 305.641 753.049 303.831 755.375 303.831C757.702 303.831 759.511 305.641 759.511 307.968Z",
    fill: "url(#paint169_radial_2_12269)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M820.518 224.189C820.518 226.516 818.709 228.326 816.382 228.326C814.056 228.326 812.246 226.516 812.246 224.189C812.246 221.861 814.056 220.051 816.382 220.051C818.709 219.793 820.518 221.861 820.518 224.189Z",
    fill: "url(#paint170_radial_2_12269)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M886.953 223.413C888.809 223.413 890.314 221.908 890.314 220.051C890.314 218.194 888.809 216.689 886.953 216.689C885.097 216.689 883.593 218.194 883.593 220.051C883.593 221.908 885.097 223.413 886.953 223.413Z",
    fill: "url(#paint171_radial_2_12269)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M959.592 264.785C961.59 264.785 963.211 263.164 963.211 261.165C963.211 259.166 961.59 257.545 959.592 257.545C957.593 257.545 955.973 259.166 955.973 261.165C955.973 263.164 957.593 264.785 959.592 264.785Z",
    fill: "url(#paint172_radial_2_12269)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M1007.93 296.074C1007.93 297.884 1006.64 299.177 1004.83 299.177C1003.02 299.177 1001.73 297.884 1001.73 296.074C1001.73 294.264 1003.02 292.971 1004.83 292.971C1006.64 292.971 1007.93 294.264 1007.93 296.074Z",
    fill: "url(#paint173_radial_2_12269)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M1021.63 363.563C1021.63 365.115 1020.6 366.149 1019.05 366.149C1017.49 366.149 1016.46 365.115 1016.46 363.563C1016.46 362.012 1017.49 360.978 1019.05 360.978C1020.6 360.978 1021.63 362.27 1021.63 363.563Z",
    fill: "url(#paint174_radial_2_12269)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M1019.3 416.055C1020.87 416.055 1022.15 414.781 1022.15 413.211C1022.15 411.64 1020.87 410.366 1019.3 410.366C1017.73 410.366 1016.46 411.64 1016.46 413.211C1016.46 414.781 1017.73 416.055 1019.3 416.055Z",
    fill: "url(#paint175_radial_2_12269)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M982.598 441.654C984.74 441.654 986.476 439.918 986.476 437.776C986.476 435.634 984.74 433.897 982.598 433.897C980.457 433.897 978.721 435.634 978.721 437.776C978.721 439.918 980.457 441.654 982.598 441.654Z",
    fill: "url(#paint176_radial_2_12269)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M929.347 434.931C929.347 437.517 927.279 439.586 924.694 439.586C922.109 439.586 920.041 437.517 920.041 434.931C920.041 432.346 922.109 430.277 924.694 430.277C927.279 430.277 929.347 432.346 929.347 434.931Z",
    fill: "url(#paint177_radial_2_12269)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M912.027 453.291C914.454 453.291 916.422 451.323 916.422 448.895C916.422 446.467 914.454 444.499 912.027 444.499C909.6 444.499 907.633 446.467 907.633 448.895C907.633 451.323 909.6 453.291 912.027 453.291Z",
    fill: "url(#paint178_radial_2_12269)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M989.577 394.852C989.577 396.662 988.026 398.213 986.217 398.213C984.407 398.213 982.856 396.662 982.856 394.852C982.856 393.042 984.407 391.49 986.217 391.49C988.285 391.49 989.577 393.042 989.577 394.852Z",
    fill: "url(#paint179_radial_2_12269)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M993.196 460.789C993.196 462.858 991.387 464.668 989.319 464.668C987.251 464.668 985.441 462.858 985.441 460.789C985.441 458.72 987.251 456.91 989.319 456.91C991.387 456.652 993.196 458.462 993.196 460.789Z",
    fill: "url(#paint180_radial_2_12269)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M992.678 490.785C992.678 493.112 990.869 494.922 988.542 494.922C986.216 494.922 984.406 493.112 984.406 490.785C984.406 488.457 986.216 486.647 988.542 486.647C990.869 486.647 992.678 488.457 992.678 490.785Z",
    fill: "url(#paint181_radial_2_12269)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M1043.86 510.695C1043.86 512.505 1042.57 513.798 1040.76 513.798C1038.95 513.798 1037.66 512.505 1037.66 510.695C1037.66 508.885 1038.95 507.592 1040.76 507.592C1042.57 507.592 1043.86 508.885 1043.86 510.695Z",
    fill: "url(#paint182_radial_2_12269)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M926.245 546.379C927.958 546.379 929.347 544.99 929.347 543.276C929.347 541.563 927.958 540.173 926.245 540.173C924.531 540.173 923.143 541.563 923.143 543.276C923.143 544.99 924.531 546.379 926.245 546.379Z",
    fill: "url(#paint183_radial_2_12269)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M902.203 550.517C902.203 552.068 901.169 553.102 899.618 553.102C898.067 553.102 897.033 552.068 897.033 550.517C897.033 548.965 898.067 547.931 899.618 547.931C900.911 548.189 902.203 549.224 902.203 550.517Z",
    fill: "url(#paint184_radial_2_12269)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M889.796 571.203C889.796 572.496 888.762 573.789 887.211 573.789C885.918 573.789 884.626 572.754 884.626 571.203C884.626 569.652 885.66 568.617 887.211 568.617C888.762 568.876 889.796 569.91 889.796 571.203Z",
    fill: "url(#paint185_radial_2_12269)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M845.334 567.842C845.334 569.393 844.3 570.427 842.749 570.427C841.198 570.427 840.164 569.393 840.164 567.842C840.164 566.29 841.198 565.256 842.749 565.256C844.3 565.256 845.334 566.29 845.334 567.842Z",
    fill: "url(#paint186_radial_2_12269)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M762.097 540.173C762.097 542.242 760.287 544.052 758.219 544.052C756.151 544.052 754.342 542.242 754.342 540.173C754.342 538.104 756.151 536.294 758.219 536.294C760.546 536.553 762.097 538.104 762.097 540.173Z",
    fill: "url(#paint187_radial_2_12269)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M613.201 497.508C613.201 499.576 611.65 501.128 609.582 501.128C607.514 501.128 605.963 499.576 605.963 497.508C605.963 495.439 607.514 493.888 609.582 493.888C611.65 494.146 613.201 495.698 613.201 497.508Z",
    fill: "url(#paint188_radial_2_12269)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M572.099 525.951C574.383 525.951 576.235 524.099 576.235 521.814C576.235 519.529 574.383 517.677 572.099 517.677C569.815 517.677 567.963 519.529 567.963 521.814C567.963 524.099 569.815 525.951 572.099 525.951Z",
    fill: "url(#paint189_radial_2_12269)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M542.888 499.576C542.888 502.162 540.82 504.231 538.235 504.231C535.65 504.231 533.582 502.162 533.582 499.576C533.582 496.991 535.65 494.922 538.235 494.922C540.82 494.922 542.888 496.991 542.888 499.576Z",
    fill: "url(#paint190_radial_2_12269)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M989.319 563.962C991.46 563.962 993.196 562.226 993.196 560.084C993.196 557.942 991.46 556.205 989.319 556.205C987.177 556.205 985.441 557.942 985.441 560.084C985.441 562.226 987.177 563.962 989.319 563.962Z",
    fill: "url(#paint191_radial_2_12269)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M1090.65 531.123C1090.65 532.675 1089.36 533.968 1087.81 533.968C1086.26 533.968 1084.96 532.675 1084.96 531.123C1084.96 529.572 1086.26 528.279 1087.81 528.279C1089.36 528.279 1090.65 529.572 1090.65 531.123Z",
    fill: "url(#paint192_radial_2_12269)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M1134.08 507.075C1134.08 509.144 1132.53 510.695 1130.46 510.695C1128.39 510.695 1126.84 509.144 1126.84 507.075C1126.84 505.007 1128.39 503.455 1130.46 503.455C1132.53 503.455 1134.08 505.007 1134.08 507.075Z",
    fill: "url(#paint193_radial_2_12269)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M1067.39 559.05C1068.96 559.05 1070.23 557.777 1070.23 556.206C1070.23 554.635 1068.96 553.361 1067.39 553.361C1065.82 553.361 1064.54 554.635 1064.54 556.206C1064.54 557.777 1065.82 559.05 1067.39 559.05Z",
    fill: "url(#paint194_radial_2_12269)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M932.708 619.558C932.708 621.627 930.899 623.437 928.831 623.437C926.763 623.437 924.953 621.627 924.953 619.558C924.953 617.489 926.763 615.679 928.831 615.679C930.899 615.679 932.708 617.489 932.708 619.558Z",
    fill: "url(#paint195_radial_2_12269)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M886.436 666.361C886.436 668.947 884.368 670.757 882.041 670.757C879.456 670.757 877.646 668.688 877.646 666.361C877.646 663.775 879.714 661.965 882.041 661.965C884.368 661.965 886.436 663.775 886.436 666.361Z",
    fill: "url(#paint196_radial_2_12269)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M658.696 671.532C658.696 673.86 656.886 675.67 654.56 675.67C652.233 675.67 650.424 673.86 650.424 671.532C650.424 669.205 652.233 667.395 654.56 667.395C656.886 667.654 658.696 669.464 658.696 671.532Z",
    fill: "url(#paint197_radial_2_12269)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M777.348 619.04C777.348 621.368 775.28 623.436 772.953 623.436C770.627 623.436 768.559 621.368 768.559 619.04C768.559 616.713 770.627 614.645 772.953 614.645C775.538 614.645 777.348 616.713 777.348 619.04Z",
    fill: "url(#paint198_radial_2_12269)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M807.593 609.99C809.735 609.99 811.471 608.253 811.471 606.111C811.471 603.969 809.735 602.232 807.593 602.232C805.452 602.232 803.716 603.969 803.716 606.111C803.716 608.253 805.452 609.99 807.593 609.99Z",
    fill: "url(#paint199_radial_2_12269)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M860.068 542.759C861.639 542.759 862.912 541.486 862.912 539.915C862.912 538.344 861.639 537.07 860.068 537.07C858.498 537.07 857.225 538.344 857.225 539.915C857.225 541.486 858.498 542.759 860.068 542.759Z",
    fill: "url(#paint200_radial_2_12269)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M915.646 492.595C915.646 494.663 914.095 496.215 912.027 496.215C909.959 496.215 908.408 494.663 908.408 492.595C908.408 490.526 909.959 488.975 912.027 488.975C914.095 488.975 915.646 490.526 915.646 492.595Z",
    fill: "url(#paint201_radial_2_12269)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M948.993 457.687C948.993 460.014 947.184 461.565 945.116 461.565C942.789 461.565 941.238 459.755 941.238 457.687C941.238 455.359 943.048 453.808 945.116 453.808C947.442 453.549 948.993 455.359 948.993 457.687Z",
    fill: "url(#paint202_radial_2_12269)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M1030.16 341.067C1031.88 341.067 1033.26 339.678 1033.26 337.964C1033.26 336.25 1031.88 334.861 1030.16 334.861C1028.45 334.861 1027.06 336.25 1027.06 337.964C1027.06 339.678 1028.45 341.067 1030.16 341.067Z",
    fill: "url(#paint203_radial_2_12269)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M1066.09 355.288C1066.09 357.099 1064.8 358.391 1062.99 358.391C1061.18 358.391 1059.89 357.099 1059.89 355.288C1059.89 353.478 1061.18 352.186 1062.99 352.186C1064.8 352.186 1066.09 353.478 1066.09 355.288Z",
    fill: "url(#paint204_radial_2_12269)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.34 202.726C1020.34 204.278 1019.05 205.571 1017.5 205.571C1015.94 205.571 1014.65 204.278 1014.65 202.726C1014.65 201.175 1015.94 199.882 1017.5 199.882C1019.05 199.882 1020.34 201.175 1020.34 202.726Z",
    fill: "url(#paint205_radial_2_12269)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M996.815 199.106C998.386 199.106 999.659 197.832 999.659 196.261C999.659 194.69 998.386 193.417 996.815 193.417C995.245 193.417 993.972 194.69 993.972 196.261C993.972 197.832 995.245 199.106 996.815 199.106Z",
    fill: "url(#paint206_radial_2_12269)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M963.21 184.108C963.21 185.66 961.918 186.952 960.367 186.952C958.816 186.952 957.523 185.66 957.523 184.108C957.523 182.557 958.816 181.264 960.367 181.264C961.918 181.264 963.21 182.557 963.21 184.108Z",
    fill: "url(#paint207_radial_2_12269)"
  }))), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M789.471 491.765C889.309 491.765 970.243 410.628 970.243 310.54C970.243 210.452 889.309 129.315 789.471 129.315C689.634 129.315 608.699 210.452 608.699 310.54C608.699 410.628 689.634 491.765 789.471 491.765Z",
    fill: "url(#paint208_linear_2_12269)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M789.471 488.431C887.472 488.431 966.918 408.786 966.918 310.54C966.918 212.293 887.472 132.649 789.471 132.649C691.47 132.649 612.024 212.293 612.024 310.54C612.024 408.786 691.47 488.431 789.471 488.431Z",
    fill: "url(#paint209_linear_2_12269)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M796.584 132.649C895.514 132.649 975.693 212.288 975.693 310.54C975.693 408.792 895.514 488.431 796.584 488.431C697.654 488.431 617.475 408.792 617.475 310.54C617.475 212.38 697.654 132.649 796.584 132.649Z",
    fill: "url(#paint210_radial_2_12269)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M789.472 459.447C871.505 459.447 938.006 392.779 938.006 310.54C938.006 228.302 871.505 161.634 789.472 161.634C707.439 161.634 640.938 228.302 640.938 310.54C640.938 392.779 707.439 459.447 789.472 459.447Z",
    fill: "url(#paint211_linear_2_12269)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M789.471 451.667C867.219 451.667 930.246 388.483 930.246 310.54C930.246 232.597 867.219 169.413 789.471 169.413C711.723 169.413 648.696 232.597 648.696 310.54C648.696 388.483 711.723 451.667 789.471 451.667Z",
    fill: "url(#paint212_linear_2_12269)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M789.471 447.5C864.923 447.5 926.089 386.181 926.089 310.54C926.089 234.899 864.923 173.58 789.471 173.58C714.019 173.58 652.853 234.899 652.853 310.54C652.853 386.181 714.019 447.5 789.471 447.5Z",
    fill: "url(#paint213_linear_2_12269)"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.58
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M669.758 329.524C671.605 329.524 673.083 327.949 673.083 326.005C673.083 324.153 671.698 322.671 670.035 322.486V285.537L689.064 265.349V248.403C690.819 248.31 692.112 246.736 692.112 244.884C692.112 242.939 690.634 241.365 688.787 241.365C686.939 241.365 685.461 242.939 685.461 244.884C685.461 246.736 686.847 248.218 688.51 248.403V265.164L669.481 285.352V322.578C667.726 322.671 666.433 324.245 666.433 326.097C666.433 327.949 667.911 329.524 669.758 329.524ZM686.662 244.884C686.662 243.588 687.586 242.569 688.787 242.569C689.987 242.569 690.911 243.588 690.911 244.884C690.911 246.181 689.987 247.199 688.787 247.199C687.586 247.199 686.662 246.181 686.662 244.884ZM669.758 323.782C670.959 323.782 671.883 324.801 671.883 326.097C671.883 327.394 670.959 328.412 669.758 328.412C668.557 328.412 667.633 327.394 667.633 326.097C667.633 324.801 668.557 323.782 669.758 323.782Z",
    fill: "#2BBAA0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M726.936 268.776C728.691 268.776 730.076 267.294 730.261 265.535H742.824C742.916 267.387 744.394 268.776 746.149 268.776C747.997 268.776 749.475 267.201 749.475 265.257C749.475 263.312 747.997 261.738 746.149 261.738C744.394 261.738 743.008 263.219 742.824 264.979H730.261C730.169 263.127 728.691 261.738 726.936 261.738C725.088 261.738 723.61 263.312 723.61 265.257C723.703 267.201 725.181 268.776 726.936 268.776ZM746.149 262.942C747.35 262.942 748.274 263.96 748.274 265.257C748.274 266.553 747.35 267.572 746.149 267.572C744.948 267.572 744.025 266.553 744.025 265.257C744.025 263.96 744.948 262.942 746.149 262.942ZM726.936 262.942C728.137 262.942 729.06 263.96 729.06 265.257C729.06 266.553 728.137 267.572 726.936 267.572C725.735 267.572 724.811 266.553 724.811 265.257C724.811 263.96 725.827 262.942 726.936 262.942Z",
    fill: "#2BBAA0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M715.389 267.942C715.943 268.405 716.682 268.776 717.513 268.776C719.361 268.776 720.839 267.201 720.839 265.257C720.839 263.312 719.361 261.738 717.513 261.738C715.666 261.738 714.188 263.312 714.188 265.257C714.188 266.183 714.557 267.016 715.019 267.572L698.023 285.352V302.298C696.268 302.391 694.975 303.965 694.975 305.817C694.975 307.762 696.453 309.336 698.3 309.336C700.147 309.336 701.625 307.762 701.625 305.817C701.625 303.965 700.24 302.483 698.577 302.298V285.537L715.389 267.942ZM717.421 262.942C718.622 262.942 719.546 263.96 719.546 265.257C719.546 266.553 718.622 267.572 717.421 267.572C716.22 267.572 715.296 266.553 715.296 265.257C715.296 263.96 716.313 262.942 717.421 262.942ZM700.425 305.817C700.425 307.113 699.501 308.132 698.3 308.132C697.099 308.132 696.175 307.113 696.175 305.817C696.175 304.521 697.099 303.502 698.3 303.502C699.501 303.594 700.425 304.613 700.425 305.817Z",
    fill: "#2BBAA0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M726.936 278.869C728.691 278.869 730.076 277.388 730.261 275.628H742.824C742.916 277.48 744.394 278.869 746.149 278.869C747.997 278.869 749.475 277.295 749.475 275.35C749.475 273.406 747.997 271.832 746.149 271.832C744.394 271.832 743.008 273.313 742.824 275.073H730.261C730.169 273.221 728.691 271.832 726.936 271.832C725.088 271.832 723.61 273.406 723.61 275.35C723.61 277.295 725.181 278.869 726.936 278.869ZM746.149 273.128C747.35 273.128 748.274 274.147 748.274 275.443C748.274 276.74 747.35 277.758 746.149 277.758C744.948 277.758 744.025 276.74 744.025 275.443C744.025 274.147 744.948 273.128 746.149 273.128ZM726.936 273.128C728.137 273.128 729.06 274.147 729.06 275.443C729.06 276.74 728.137 277.758 726.936 277.758C725.735 277.758 724.811 276.74 724.811 275.443C724.811 274.147 725.827 273.128 726.936 273.128Z",
    fill: "#2BBAA0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M726.936 288.871C728.691 288.871 730.076 287.389 730.261 285.63H742.824C742.916 287.482 744.394 288.871 746.149 288.871C747.997 288.871 749.475 287.297 749.475 285.352C749.475 283.407 747.997 281.833 746.149 281.833C744.394 281.833 743.008 283.315 742.824 285.074H730.261C730.169 283.222 728.691 281.833 726.936 281.833C725.088 281.833 723.61 283.407 723.61 285.352C723.61 287.297 725.088 288.871 726.936 288.871ZM746.057 283.129C747.258 283.129 748.181 284.148 748.181 285.445C748.181 286.741 747.258 287.76 746.057 287.76C744.856 287.76 743.932 286.741 743.932 285.445C743.932 284.148 744.856 283.129 746.057 283.129ZM726.936 283.129C728.137 283.129 729.06 284.148 729.06 285.445C729.06 286.741 728.137 287.76 726.936 287.76C725.735 287.76 724.811 286.741 724.811 285.445C724.719 284.148 725.735 283.129 726.936 283.129Z",
    fill: "#2BBAA0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M726.936 299.057C728.691 299.057 730.076 297.575 730.261 295.816H742.824C742.916 297.668 744.394 299.057 746.149 299.057C747.997 299.057 749.475 297.483 749.475 295.538C749.475 293.593 747.997 292.019 746.149 292.019C744.394 292.019 743.008 293.501 742.824 295.26H730.261C730.169 293.408 728.691 292.019 726.936 292.019C725.088 292.019 723.61 293.593 723.61 295.538C723.61 297.483 725.088 299.057 726.936 299.057ZM746.057 293.315C747.258 293.315 748.181 294.334 748.181 295.631C748.181 296.927 747.258 297.946 746.057 297.946C744.856 297.946 743.932 296.927 743.932 295.631C743.932 294.334 744.856 293.315 746.057 293.315ZM726.936 293.315C728.137 293.315 729.06 294.334 729.06 295.631C729.06 296.927 728.137 297.946 726.936 297.946C725.735 297.946 724.811 296.927 724.811 295.631C724.719 294.334 725.735 293.315 726.936 293.315Z",
    fill: "#2BBAA0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M726.936 309.336C728.691 309.336 730.076 307.855 730.261 306.095H742.824C742.916 307.947 744.394 309.336 746.149 309.336C747.997 309.336 749.475 307.762 749.475 305.817C749.475 303.873 747.997 302.298 746.149 302.298C744.394 302.298 743.008 303.78 742.824 305.539H730.261C730.169 303.687 728.691 302.298 726.936 302.298C725.088 302.298 723.61 303.873 723.61 305.817C723.61 307.762 725.088 309.336 726.936 309.336ZM746.057 303.595C747.258 303.595 748.181 304.613 748.181 305.91C748.181 307.206 747.258 308.225 746.057 308.225C744.856 308.225 743.932 307.206 743.932 305.91C743.932 304.613 744.856 303.595 746.057 303.595ZM726.936 303.595C728.137 303.595 729.06 304.613 729.06 305.91C729.06 307.206 728.137 308.225 726.936 308.225C725.735 308.225 724.811 307.206 724.811 305.91C724.719 304.613 725.735 303.595 726.936 303.595Z",
    fill: "#2BBAA0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M774.877 319.8L774.969 248.403C776.724 248.31 778.017 246.736 778.017 244.884C778.017 242.939 776.54 241.365 774.692 241.365C772.845 241.365 771.367 242.939 771.367 244.884C771.367 246.736 772.752 248.218 774.415 248.403V319.522L726.751 359.99L726.659 360.083V373.232C724.904 373.325 723.61 374.899 723.61 376.751C723.61 378.696 725.088 380.27 726.936 380.27C728.783 380.27 730.261 378.696 730.261 376.751C730.261 374.899 728.876 373.417 727.213 373.232V360.268L774.877 319.8ZM772.568 244.884C772.568 243.588 773.491 242.569 774.692 242.569C775.893 242.569 776.817 243.588 776.817 244.884C776.817 246.181 775.893 247.199 774.692 247.199C773.491 247.199 772.568 246.181 772.568 244.884ZM729.153 376.751C729.153 378.048 728.229 379.066 727.028 379.066C725.827 379.066 724.904 378.048 724.904 376.751C724.904 375.455 725.827 374.436 727.028 374.436C728.137 374.436 729.153 375.455 729.153 376.751Z",
    fill: "#2BBAA0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M784.483 323.504L784.576 248.403C786.331 248.31 787.624 246.736 787.624 244.884C787.624 242.939 786.146 241.365 784.299 241.365C782.451 241.365 780.973 242.939 780.973 244.884C780.973 246.736 782.359 248.218 784.021 248.403V323.227C771.459 334.154 739.406 361.935 736.542 363.602C736.542 363.602 736.45 363.602 736.357 363.602C736.265 363.602 736.173 363.694 736.173 363.879C736.173 364.713 736.173 369.991 736.265 373.232C734.602 373.325 733.217 374.899 733.217 376.751C733.217 378.696 734.695 380.27 736.542 380.27C738.39 380.27 739.868 378.696 739.868 376.751C739.868 374.899 738.482 373.417 736.819 373.232L736.727 364.25C736.727 364.157 736.727 364.157 736.727 364.065C737.651 363.602 741.53 360.546 760.836 343.97C772.567 333.876 784.391 323.597 784.483 323.504ZM782.174 244.884C782.174 243.588 783.098 242.569 784.299 242.569C785.499 242.569 786.423 243.588 786.423 244.884C786.423 246.181 785.499 247.199 784.299 247.199C783.19 247.199 782.174 246.181 782.174 244.884ZM738.667 376.751C738.667 378.048 737.743 379.066 736.542 379.066C735.341 379.066 734.418 378.048 734.418 376.751C734.418 375.455 735.341 374.436 736.542 374.436C737.743 374.436 738.667 375.455 738.667 376.751Z",
    fill: "#2BBAA0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M765.362 316.096L765.455 248.31C767.21 248.218 768.503 246.643 768.503 244.791C768.503 242.847 767.025 241.272 765.177 241.272C763.33 241.272 761.852 242.847 761.852 244.791C761.852 246.643 763.238 248.125 764.9 248.31V315.726L717.236 356.193L717.144 356.286V373.14C715.389 373.232 714.096 374.806 714.096 376.658C714.096 378.603 715.574 380.177 717.421 380.177C719.269 380.177 720.746 378.603 720.746 376.658C720.746 374.806 719.361 373.325 717.698 373.14V356.564L765.362 316.096ZM763.053 244.884C763.053 243.588 763.977 242.569 765.177 242.569C766.378 242.569 767.302 243.588 767.302 244.884C767.302 246.18 766.378 247.199 765.177 247.199C764.069 247.199 763.053 246.18 763.053 244.884ZM719.638 376.751C719.638 378.048 718.714 379.066 717.513 379.066C716.313 379.066 715.389 378.048 715.389 376.751C715.389 375.455 716.313 374.436 717.513 374.436C718.622 374.436 719.638 375.455 719.638 376.751Z",
    fill: "#2BBAA0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M745.964 367.306L745.78 373.232C744.025 373.325 742.731 374.899 742.731 376.751C742.731 378.696 744.209 380.27 746.057 380.27C747.904 380.27 749.382 378.696 749.382 376.751C749.382 374.899 747.997 373.417 746.334 373.232L746.426 367.676L793.998 327.208L794.09 327.116V248.403C795.845 248.31 797.139 246.736 797.139 244.884C797.139 242.939 795.661 241.365 793.813 241.365C791.966 241.365 790.488 242.939 790.488 244.884C790.488 246.736 791.873 248.218 793.536 248.403V326.838L745.964 367.306ZM748.181 376.751C748.181 378.048 747.258 379.066 746.057 379.066C744.856 379.066 743.932 378.048 743.932 376.751C743.932 375.455 744.856 374.436 746.057 374.436C747.258 374.436 748.181 375.455 748.181 376.751ZM791.689 244.884C791.689 243.588 792.612 242.569 793.813 242.569C795.014 242.569 795.938 243.588 795.938 244.884C795.938 246.181 795.014 247.199 793.813 247.199C792.705 247.199 791.689 246.181 791.689 244.884Z",
    fill: "#2BBAA0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M707.907 339.617C709.662 339.617 711.048 338.136 711.233 336.376H721.671L743.563 318.411C744.21 319.152 745.041 319.615 746.057 319.615C747.905 319.615 749.382 318.041 749.382 316.096C749.382 314.151 747.905 312.577 746.057 312.577C744.21 312.577 742.732 314.151 742.732 316.096C742.732 316.837 742.916 317.485 743.286 318.041L721.486 335.913H711.233C711.14 334.061 709.662 332.672 707.907 332.672C706.06 332.672 704.582 334.246 704.582 336.191C704.674 338.043 706.152 339.617 707.907 339.617ZM746.057 313.781C747.258 313.781 748.182 314.8 748.182 316.096C748.182 317.393 747.258 318.411 746.057 318.411C744.856 318.411 743.933 317.393 743.933 316.096C743.933 314.8 744.856 313.781 746.057 313.781ZM707.907 333.876C709.108 333.876 710.032 334.895 710.032 336.191C710.032 337.487 709.108 338.506 707.907 338.506C706.707 338.506 705.783 337.487 705.783 336.191C705.783 334.895 706.799 333.876 707.907 333.876Z",
    fill: "#2BBAA0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M701.534 326.004C701.534 324.06 700.056 322.485 698.208 322.485C696.361 322.485 694.883 324.06 694.883 326.004C694.883 327.856 696.268 329.338 697.931 329.523V373.232C696.176 373.325 694.883 374.899 694.883 376.751C694.883 378.696 696.361 380.27 698.208 380.27C700.056 380.27 701.534 378.696 701.534 376.751C701.534 374.899 700.148 373.417 698.485 373.232V329.523C700.24 329.431 701.534 327.856 701.534 326.004ZM700.425 376.751C700.425 378.047 699.501 379.066 698.301 379.066C697.1 379.066 696.176 378.047 696.176 376.751C696.176 375.454 697.1 374.436 698.301 374.436C699.501 374.436 700.425 375.454 700.425 376.751ZM698.301 328.319C697.1 328.319 696.176 327.301 696.176 326.004C696.176 324.708 697.1 323.689 698.301 323.689C699.501 323.689 700.425 324.708 700.425 326.004C700.425 327.301 699.501 328.319 698.301 328.319Z",
    fill: "#2BBAA0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M797.139 366.38C797.139 364.435 795.661 362.861 793.813 362.861C791.966 362.861 790.488 364.435 790.488 366.38C790.488 368.232 791.873 369.713 793.536 369.899V406.94H777.925C777.833 405.088 776.355 403.699 774.6 403.699C772.752 403.699 771.274 405.273 771.274 407.218C771.274 409.162 772.752 410.737 774.6 410.737C776.355 410.737 777.74 409.255 777.925 407.496H793.998V369.899C795.753 369.713 797.139 368.232 797.139 366.38ZM774.692 409.44C773.491 409.44 772.568 408.422 772.568 407.125C772.568 405.829 773.491 404.81 774.692 404.81C775.893 404.81 776.817 405.829 776.817 407.125C776.817 408.422 775.893 409.44 774.692 409.44ZM793.813 368.695C792.612 368.695 791.689 367.676 791.689 366.38C791.689 365.083 792.612 364.065 793.813 364.065C795.014 364.065 795.938 365.083 795.938 366.38C795.938 367.676 795.014 368.695 793.813 368.695Z",
    fill: "#2BBAA0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M803.42 369.898C805.268 369.898 806.746 368.324 806.746 366.379C806.746 364.527 805.36 363.046 803.697 362.861V326.097L822.818 305.91L822.911 299.057C824.666 298.964 825.959 297.39 825.959 295.538C825.959 293.593 824.481 292.019 822.634 292.019C820.786 292.019 819.308 293.593 819.308 295.538C819.308 297.39 820.694 298.872 822.356 299.057L822.264 305.724L803.143 325.912V362.861C801.388 362.953 800.095 364.527 800.095 366.379C800.095 368.324 801.573 369.898 803.42 369.898ZM820.417 295.538C820.417 294.242 821.34 293.223 822.541 293.223C823.742 293.223 824.666 294.242 824.666 295.538C824.666 296.834 823.742 297.853 822.541 297.853C821.34 297.853 820.417 296.834 820.417 295.538ZM803.42 364.157C804.621 364.157 805.545 365.176 805.545 366.472C805.545 367.769 804.621 368.787 803.42 368.787C802.219 368.787 801.296 367.769 801.296 366.472C801.296 365.176 802.219 364.157 803.42 364.157Z",
    fill: "#2BBAA0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M857.365 346.377C857.365 348.322 858.843 349.896 860.691 349.896C862.538 349.896 864.016 348.322 864.016 346.377C864.016 344.525 862.63 343.044 860.968 342.858V329.431C862.723 329.338 864.016 327.764 864.016 325.912C864.016 323.967 862.538 322.393 860.691 322.393C858.843 322.393 857.365 323.967 857.365 325.912C857.365 327.764 858.751 329.246 860.413 329.431V342.858C858.751 343.044 857.365 344.525 857.365 346.377ZM858.566 326.005C858.566 324.708 859.49 323.69 860.691 323.69C861.891 323.69 862.815 324.708 862.815 326.005C862.815 327.301 861.891 328.32 860.691 328.32C859.49 328.32 858.566 327.301 858.566 326.005ZM860.691 344.062C861.891 344.062 862.815 345.081 862.815 346.377C862.815 347.674 861.891 348.692 860.691 348.692C859.49 348.692 858.566 347.674 858.566 346.377C858.566 345.081 859.49 344.062 860.691 344.062Z",
    fill: "#2BBAA0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M854.501 326.004C854.501 324.06 853.023 322.485 851.176 322.485C849.329 322.485 847.851 324.06 847.851 326.004C847.851 327.856 849.236 329.338 850.899 329.523V342.951C849.144 343.043 847.851 344.618 847.851 346.47C847.851 348.414 849.329 349.989 851.176 349.989C853.023 349.989 854.501 348.414 854.501 346.47C854.501 344.618 853.116 343.136 851.453 342.951V329.523C853.116 329.338 854.501 327.856 854.501 326.004ZM853.301 346.377C853.301 347.673 852.377 348.692 851.176 348.692C849.975 348.692 849.051 347.673 849.051 346.377C849.051 345.081 849.975 344.062 851.176 344.062C852.377 344.062 853.301 345.081 853.301 346.377ZM851.176 328.319C849.975 328.319 849.051 327.301 849.051 326.004C849.051 324.708 849.975 323.689 851.176 323.689C852.377 323.689 853.301 324.708 853.301 326.004C853.301 327.301 852.377 328.319 851.176 328.319Z",
    fill: "#2BBAA0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M844.988 325.912C844.988 323.967 843.51 322.393 841.662 322.393C839.815 322.393 838.337 323.967 838.337 325.912C838.337 327.764 839.722 329.246 841.385 329.431V342.858C839.63 342.951 838.337 344.525 838.337 346.377C838.337 348.322 839.815 349.896 841.662 349.896C843.51 349.896 844.988 348.322 844.988 346.377C844.988 344.525 843.602 343.044 841.939 342.858V329.431C843.695 329.246 844.988 327.764 844.988 325.912ZM843.879 346.285C843.879 347.581 842.956 348.6 841.755 348.6C840.554 348.6 839.63 347.581 839.63 346.285C839.63 344.988 840.554 343.97 841.755 343.97C842.956 343.97 843.879 345.081 843.879 346.285ZM841.755 328.227C840.554 328.227 839.63 327.208 839.63 325.912C839.63 324.616 840.554 323.597 841.755 323.597C842.956 323.597 843.879 324.616 843.879 325.912C843.879 327.208 842.863 328.227 841.755 328.227Z",
    fill: "#2BBAA0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M835.473 325.912C835.473 323.967 833.995 322.393 832.148 322.393C830.3 322.393 828.822 323.967 828.822 325.912C828.822 327.764 830.208 329.246 831.871 329.431V342.858C830.115 342.951 828.822 344.525 828.822 346.377C828.822 348.322 830.3 349.896 832.148 349.896C833.995 349.896 835.473 348.322 835.473 346.377C835.473 344.525 834.087 343.044 832.425 342.858V329.431C834.087 329.246 835.473 327.764 835.473 325.912ZM834.272 346.285C834.272 347.581 833.348 348.6 832.148 348.6C830.947 348.6 830.023 347.581 830.023 346.285C830.023 344.988 830.947 343.97 832.148 343.97C833.348 344.062 834.272 345.081 834.272 346.285ZM832.148 328.227C830.947 328.227 830.023 327.208 830.023 325.912C830.023 324.616 830.947 323.597 832.148 323.597C833.348 323.597 834.272 324.616 834.272 325.912C834.272 327.208 833.348 328.227 832.148 328.227Z",
    fill: "#2BBAA0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M819.216 346.285C819.216 348.229 820.694 349.803 822.541 349.803C824.389 349.803 825.867 348.229 825.867 346.285C825.867 344.432 824.481 342.951 822.818 342.766V329.338C824.573 329.246 825.867 327.671 825.867 325.819C825.867 323.875 824.389 322.3 822.541 322.3C820.694 322.3 819.216 323.875 819.216 325.819C819.216 327.671 820.601 329.153 822.264 329.338V342.766C820.509 342.951 819.216 344.432 819.216 346.285ZM820.324 325.912C820.324 324.615 821.248 323.597 822.449 323.597C823.65 323.597 824.573 324.615 824.573 325.912C824.573 327.208 823.65 328.227 822.449 328.227C821.34 328.227 820.324 327.208 820.324 325.912ZM822.449 344.062C823.65 344.062 824.573 345.081 824.573 346.377C824.573 347.674 823.65 348.692 822.449 348.692C821.248 348.692 820.324 347.674 820.324 346.377C820.324 345.081 821.34 344.062 822.449 344.062Z",
    fill: "#2BBAA0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M822.541 363.231C820.694 363.231 819.216 364.805 819.216 366.75C819.216 368.695 820.694 370.269 822.541 370.269C824.296 370.269 825.682 368.787 825.867 367.028L870.298 366.75H870.482V285.815H917.407C917.407 285.629 917.315 285.444 917.315 285.352H870.02V366.287L825.867 366.565C825.774 364.62 824.296 363.231 822.541 363.231ZM822.541 368.972C821.34 368.972 820.417 367.954 820.417 366.657C820.417 365.361 821.34 364.342 822.541 364.342C823.742 364.342 824.666 365.361 824.666 366.657C824.758 367.954 823.742 368.972 822.541 368.972Z",
    fill: "#2BBAA0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M879.535 376.566H825.867C825.774 374.714 824.296 373.325 822.541 373.325C820.694 373.325 819.216 374.899 819.216 376.844C819.216 378.788 820.694 380.363 822.541 380.363C824.296 380.363 825.682 378.881 825.867 377.122H879.997V296.001H918.885C918.885 295.816 918.885 295.631 918.793 295.538H879.535V376.566ZM822.541 379.066C821.34 379.066 820.417 378.048 820.417 376.751C820.417 375.455 821.34 374.436 822.541 374.436C823.742 374.436 824.666 375.455 824.666 376.751C824.758 378.048 823.742 379.066 822.541 379.066Z",
    fill: "#2BBAA0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M822.541 390.364C824.296 390.364 825.681 388.882 825.866 387.123H889.603V306.002H919.624C919.624 305.817 919.624 305.632 919.624 305.539H889.233V386.66H825.774C825.681 384.807 824.204 383.418 822.448 383.418C820.601 383.418 819.123 384.993 819.123 386.937C819.215 388.789 820.693 390.364 822.541 390.364ZM822.541 384.53C823.742 384.53 824.665 385.548 824.665 386.845C824.665 388.141 823.742 389.16 822.541 389.16C821.34 389.16 820.416 388.141 820.416 386.845C820.416 385.548 821.34 384.53 822.541 384.53Z",
    fill: "#2BBAA0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M822.541 400.55C824.296 400.55 825.681 399.069 825.866 397.309H886.093C886.278 397.124 886.37 396.939 886.555 396.846H825.774C825.681 394.994 824.204 393.605 822.448 393.605C820.601 393.605 819.123 395.179 819.123 397.124C819.215 398.976 820.693 400.55 822.541 400.55ZM822.541 394.716C823.742 394.716 824.665 395.735 824.665 397.031C824.665 398.328 823.742 399.346 822.541 399.346C821.34 399.346 820.416 398.328 820.416 397.031C820.416 395.735 821.34 394.716 822.541 394.716Z",
    fill: "#2BBAA0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M919.439 315.633H898.748V380.548C898.933 380.27 899.025 380.085 899.21 379.807V316.096H919.439C919.439 315.911 919.439 315.818 919.439 315.633Z",
    fill: "#2BBAA0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M822.541 410.737C824.296 410.737 825.682 409.255 825.867 407.496H875.932C876.117 407.31 876.302 407.125 876.486 407.033H825.867C825.774 405.181 824.296 403.792 822.541 403.792C820.694 403.792 819.216 405.366 819.216 407.31C819.216 409.163 820.694 410.737 822.541 410.737ZM822.541 404.995C823.742 404.995 824.666 406.014 824.666 407.31C824.666 408.607 823.742 409.626 822.541 409.626C821.34 409.626 820.417 408.607 820.417 407.31C820.417 406.014 821.34 404.995 822.541 404.995Z",
    fill: "#2BBAA0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M908.262 325.727V362.953C908.446 362.583 908.539 362.212 908.724 361.934V326.19L918.515 326.282C918.515 326.097 918.515 325.912 918.607 325.819L908.262 325.727Z",
    fill: "#2BBAA0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M841.477 292.204C839.814 292.297 838.429 293.871 838.429 295.723C838.429 297.668 839.907 299.242 841.754 299.242C843.602 299.242 845.079 297.668 845.079 295.723C845.079 293.871 843.694 292.39 842.031 292.204L841.846 255.256H867.064C867.156 257.108 868.634 258.497 870.389 258.497C872.237 258.497 873.715 256.923 873.715 254.978C873.715 253.033 872.237 251.459 870.389 251.459C868.634 251.459 867.249 252.941 867.064 254.7H841.385L841.477 292.204ZM870.297 252.755C871.498 252.755 872.422 253.774 872.422 255.071C872.422 256.367 871.498 257.386 870.297 257.386C869.096 257.386 868.173 256.367 868.173 255.071C868.08 253.774 869.096 252.755 870.297 252.755ZM843.879 295.631C843.879 296.927 842.955 297.946 841.754 297.946C840.553 297.946 839.63 296.927 839.63 295.631C839.63 294.334 840.553 293.316 841.754 293.316C842.955 293.316 843.879 294.427 843.879 295.631Z",
    fill: "#2BBAA0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M819.216 275.35C819.216 277.295 820.694 278.869 822.541 278.869C824.389 278.869 825.867 277.295 825.867 275.35C825.867 273.498 824.481 272.017 822.818 271.832V228.123C824.573 228.03 825.867 226.456 825.867 224.604C825.867 222.659 824.389 221.085 822.541 221.085C820.694 221.085 819.216 222.659 819.216 224.604C819.216 226.456 820.601 227.938 822.264 228.123V271.832C820.601 272.017 819.216 273.498 819.216 275.35ZM820.417 224.696C820.417 223.4 821.34 222.381 822.541 222.381C823.742 222.381 824.666 223.4 824.666 224.696C824.666 225.993 823.742 227.012 822.541 227.012C821.34 226.919 820.417 225.9 820.417 224.696ZM822.541 273.128C823.742 273.128 824.666 274.147 824.666 275.443C824.666 276.74 823.742 277.758 822.541 277.758C821.34 277.758 820.417 276.74 820.417 275.443C820.417 274.147 821.34 273.128 822.541 273.128Z",
    fill: "#2BBAA0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M828.822 204.601C828.915 206.453 830.392 207.843 832.148 207.843C833.995 207.843 835.473 206.268 835.473 204.324C835.473 202.379 833.995 200.805 832.148 200.805C830.392 200.805 829.007 202.286 828.822 204.046H812.749V241.365C810.994 241.458 809.701 243.032 809.701 244.884C809.701 246.829 811.179 248.403 813.027 248.403C814.874 248.403 816.352 246.829 816.352 244.884C816.352 243.032 814.966 241.55 813.304 241.365V204.601H828.822ZM832.055 202.009C833.256 202.009 834.18 203.027 834.18 204.324C834.18 205.62 833.256 206.639 832.055 206.639C830.854 206.639 829.931 205.62 829.931 204.324C829.931 203.027 830.854 202.009 832.055 202.009ZM815.059 244.884C815.059 246.18 814.135 247.199 812.934 247.199C811.733 247.199 810.81 246.18 810.81 244.884C810.81 243.587 811.733 242.569 812.934 242.569C814.135 242.569 815.059 243.68 815.059 244.884Z",
    fill: "#2BBAA0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M860.414 292.205C858.658 292.297 857.365 293.871 857.365 295.723C857.365 297.668 858.843 299.242 860.691 299.242C862.538 299.242 864.016 297.668 864.016 295.723C864.016 293.871 862.63 292.39 860.968 292.205V275.629H915.282C915.282 275.443 915.19 275.258 915.19 275.166H860.598V292.205H860.414ZM862.815 295.631C862.815 296.927 861.891 297.946 860.691 297.946C859.49 297.946 858.566 296.927 858.566 295.631C858.566 294.334 859.49 293.316 860.691 293.316C861.891 293.408 862.815 294.427 862.815 295.631Z",
    fill: "#2BBAA0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M850.992 292.112C849.237 292.205 847.943 293.779 847.943 295.631C847.943 297.576 849.421 299.15 851.269 299.15C853.116 299.15 854.594 297.576 854.594 295.631C854.594 293.779 853.209 292.297 851.546 292.112V265.535H912.234C912.142 265.35 912.142 265.164 912.05 265.072H851.084L850.992 292.112ZM853.301 295.538C853.301 296.835 852.377 297.853 851.176 297.853C849.976 297.853 849.052 296.835 849.052 295.538C849.052 294.242 849.976 293.223 851.176 293.223C852.377 293.316 853.301 294.334 853.301 295.538Z",
    fill: "#2BBAA0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M846.834 427.22H752.338L736.727 410.829L736.819 400.55C738.574 400.457 739.868 398.883 739.868 397.031C739.868 395.086 738.39 393.512 736.542 393.512C734.695 393.512 733.217 395.086 733.217 397.031C733.217 398.883 734.602 400.365 736.265 400.55L736.173 411.014L751.968 427.683L752.061 427.775H845.726C846.095 427.59 846.465 427.405 846.834 427.22ZM734.418 397.124C734.418 395.827 735.341 394.809 736.542 394.809C737.743 394.809 738.667 395.827 738.667 397.124C738.667 398.42 737.743 399.439 736.542 399.439C735.341 399.439 734.418 398.328 734.418 397.124Z",
    fill: "#2BBAA0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M745.872 400.55L745.964 407.218L755.571 417.496H863.184C863.461 417.311 863.646 417.126 863.923 417.033H755.848L746.334 407.032L746.241 400.55C747.904 400.457 749.289 398.883 749.289 397.031C749.289 395.086 747.812 393.512 745.964 393.512C744.117 393.512 742.639 395.086 742.639 397.031C742.731 398.976 744.117 400.457 745.872 400.55ZM746.056 394.809C747.257 394.809 748.181 395.827 748.181 397.124C748.181 398.42 747.257 399.439 746.056 399.439C744.856 399.439 743.932 398.42 743.932 397.124C743.932 395.827 744.856 394.809 746.056 394.809Z",
    fill: "#2BBAA0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M717.421 400.55C719.176 400.55 720.562 399.068 720.746 397.309H723.702C723.795 399.161 725.273 400.55 727.028 400.55C728.875 400.55 730.353 398.976 730.353 397.031C730.353 395.086 728.875 393.512 727.028 393.512C725.273 393.512 723.887 394.994 723.702 396.753H720.746C720.654 394.901 719.176 393.512 717.421 393.512C715.574 393.512 714.096 395.086 714.096 397.031C714.188 398.976 715.666 400.55 717.421 400.55ZM726.935 394.716C728.136 394.716 729.06 395.735 729.06 397.031C729.06 398.328 728.136 399.346 726.935 399.346C725.735 399.346 724.811 398.328 724.811 397.031C724.811 395.735 725.827 394.716 726.935 394.716ZM717.421 394.716C718.622 394.716 719.546 395.735 719.546 397.031C719.546 398.328 718.622 399.346 717.421 399.346C716.22 399.346 715.297 398.328 715.297 397.031C715.297 395.735 716.313 394.716 717.421 394.716Z",
    fill: "#2BBAA0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M765.178 373.232C763.423 373.232 762.038 374.714 761.853 376.473H758.897C758.805 374.621 757.327 373.232 755.571 373.232C753.724 373.232 752.246 374.806 752.246 376.751C752.246 378.696 753.724 380.27 755.571 380.27C757.327 380.27 758.712 378.788 758.897 377.029H761.853C761.945 378.881 763.423 380.27 765.178 380.27C767.026 380.27 768.504 378.696 768.504 376.751C768.504 374.806 767.026 373.232 765.178 373.232ZM755.664 378.973C754.463 378.973 753.539 377.955 753.539 376.658C753.539 375.362 754.463 374.343 755.664 374.343C756.865 374.343 757.788 375.362 757.788 376.658C757.788 377.955 756.865 378.973 755.664 378.973ZM765.178 378.973C763.977 378.973 763.054 377.955 763.054 376.658C763.054 375.362 763.977 374.343 765.178 374.343C766.379 374.343 767.303 375.362 767.303 376.658C767.303 377.955 766.379 378.973 765.178 378.973Z",
    fill: "#2BBAA0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M765.178 393.605C763.423 393.605 762.038 395.087 761.853 396.846H758.897C758.805 394.994 757.327 393.605 755.571 393.605C753.724 393.605 752.246 395.179 752.246 397.124C752.246 399.069 753.724 400.643 755.571 400.643C757.327 400.643 758.712 399.161 758.897 397.402H761.853C761.945 399.254 763.423 400.643 765.178 400.643C767.026 400.643 768.504 399.069 768.504 397.124C768.504 395.179 767.026 393.605 765.178 393.605ZM755.664 399.346C754.463 399.346 753.539 398.328 753.539 397.031C753.539 395.735 754.463 394.716 755.664 394.716C756.865 394.716 757.788 395.735 757.788 397.031C757.788 398.328 756.865 399.346 755.664 399.346ZM765.178 399.346C763.977 399.346 763.054 398.328 763.054 397.031C763.054 395.735 763.977 394.716 765.178 394.716C766.379 394.716 767.303 395.735 767.303 397.031C767.303 398.328 766.379 399.346 765.178 399.346Z",
    fill: "#2BBAA0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M816.259 254.978C816.259 253.033 814.781 251.459 812.934 251.459C811.087 251.459 809.609 253.033 809.609 254.978C809.609 256.83 810.994 258.312 812.657 258.497V274.61L803.143 285.259L803.05 285.352V302.206C801.295 302.298 800.002 303.872 800.002 305.725C800.002 307.669 801.48 309.243 803.327 309.243C805.175 309.243 806.653 307.669 806.653 305.725C806.653 303.872 805.267 302.391 803.604 302.206V285.537L813.119 274.888L813.211 274.795V258.497C814.874 258.404 816.259 256.83 816.259 254.978ZM805.544 305.632C805.544 306.928 804.621 307.947 803.42 307.947C802.219 307.947 801.295 306.928 801.295 305.632C801.295 304.335 802.219 303.317 803.42 303.317C804.621 303.317 805.544 304.428 805.544 305.632ZM812.934 257.293C811.733 257.293 810.809 256.274 810.809 254.978C810.809 253.681 811.733 252.663 812.934 252.663C814.135 252.663 815.059 253.681 815.059 254.978C815.059 256.274 814.135 257.293 812.934 257.293Z",
    fill: "#2BBAA0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M831.871 244.699L831.779 271.831C830.024 271.924 828.73 273.498 828.73 275.35C828.73 277.295 830.208 278.869 832.056 278.869C833.903 278.869 835.381 277.295 835.381 275.35C835.381 273.498 833.996 272.017 832.333 271.831V244.976L842.032 234.883V207.843C843.787 207.75 845.08 206.176 845.08 204.324C845.08 202.379 843.602 200.805 841.755 200.805C839.907 200.805 838.43 202.379 838.43 204.324C838.43 206.176 839.815 207.657 841.478 207.843V234.698L831.871 244.699ZM834.18 275.35C834.18 276.647 833.257 277.665 832.056 277.665C830.855 277.665 829.931 276.647 829.931 275.35C829.931 274.054 830.855 273.035 832.056 273.035C833.257 273.035 834.18 274.147 834.18 275.35ZM839.538 204.324C839.538 203.027 840.462 202.009 841.663 202.009C842.863 202.009 843.787 203.027 843.787 204.324C843.787 205.62 842.863 206.639 841.663 206.639C840.554 206.639 839.538 205.62 839.538 204.324Z",
    fill: "#2BBAA0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M889.325 251.459C887.478 251.459 886 253.033 886 254.978C886 256.923 887.478 258.497 889.325 258.497C891.08 258.497 892.466 257.015 892.651 255.256H907.985C907.892 255.071 907.8 254.885 907.8 254.793H892.651C892.466 252.941 891.08 251.459 889.325 251.459ZM889.325 257.293C888.125 257.293 887.201 256.274 887.201 254.978C887.201 253.681 888.125 252.663 889.325 252.663C890.526 252.663 891.45 253.681 891.45 254.978C891.45 256.274 890.526 257.293 889.325 257.293Z",
    fill: "#2BBAA0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M864.016 204.324C864.016 202.379 862.538 200.805 860.691 200.805C858.843 200.805 857.365 202.379 857.365 204.324C857.365 206.176 858.751 207.75 860.506 207.843C860.506 210.713 860.506 223.77 860.506 231.364C858.751 231.456 857.458 233.031 857.458 234.883C857.458 236.827 858.936 238.402 860.783 238.402C862.63 238.402 864.108 236.827 864.108 234.883C864.108 233.031 862.723 231.549 861.06 231.364C861.06 229.697 861.06 224.696 861.06 219.603C861.06 211.917 861.06 208.954 861.06 207.843C862.63 207.657 864.016 206.176 864.016 204.324ZM862.908 234.79C862.908 236.087 861.984 237.105 860.783 237.105C859.582 237.105 858.658 236.087 858.658 234.79C858.658 233.494 859.582 232.475 860.783 232.475C861.891 232.475 862.908 233.494 862.908 234.79ZM860.691 206.639C859.49 206.639 858.566 205.62 858.566 204.324C858.566 203.027 859.49 202.009 860.691 202.009C861.891 202.009 862.815 203.027 862.815 204.324C862.815 205.62 861.891 206.639 860.691 206.639Z",
    fill: "#2BBAA0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M870.02 207.842V231.364C868.265 231.456 866.972 233.031 866.972 234.883C866.972 236.827 868.45 238.402 870.297 238.402C872.145 238.402 873.622 236.827 873.622 234.883C873.622 233.031 872.237 231.549 870.574 231.364V207.842C870.944 207.842 871.313 207.75 871.59 207.565C871.221 207.287 870.851 206.916 870.389 206.639H870.297C869.281 206.639 868.45 205.898 868.265 204.879C867.895 204.601 867.434 204.231 867.064 203.953C867.064 204.046 867.064 204.231 867.064 204.324C866.972 206.176 868.357 207.657 870.02 207.842ZM872.422 234.79C872.422 236.086 871.498 237.105 870.297 237.105C869.096 237.105 868.173 236.086 868.173 234.79C868.173 233.494 869.096 232.475 870.297 232.475C871.406 232.475 872.422 233.494 872.422 234.79Z",
    fill: "#2BBAA0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M883.044 234.512C882.952 232.66 881.474 231.271 879.719 231.271C877.872 231.271 876.394 232.845 876.394 234.79C876.394 236.735 877.872 238.309 879.719 238.309C881.474 238.309 882.86 236.827 883.044 235.068H889.51V225.53C889.326 225.345 889.233 225.159 889.049 224.974V234.512H883.044ZM879.811 237.105C878.61 237.105 877.687 236.087 877.687 234.79C877.687 233.494 878.61 232.475 879.811 232.475C881.012 232.475 881.936 233.494 881.936 234.79C881.936 236.087 880.92 237.105 879.811 237.105Z",
    fill: "#2BBAA0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M679.272 359.99C681.119 359.99 682.597 358.416 682.597 356.471C682.597 354.526 681.119 352.952 679.272 352.952C677.517 352.952 676.131 354.434 675.946 356.193H665.416C665.508 356.378 665.508 356.564 665.601 356.656H675.946C676.131 358.601 677.517 359.99 679.272 359.99ZM679.272 354.249C680.473 354.249 681.396 355.267 681.396 356.564C681.396 357.86 680.473 358.879 679.272 358.879C678.071 358.879 677.147 357.86 677.147 356.564C677.147 355.267 678.071 354.249 679.272 354.249Z",
    fill: "#2BBAA0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M679.365 370.084C681.212 370.084 682.69 368.51 682.69 366.565C682.69 364.62 681.212 363.046 679.365 363.046C677.609 363.046 676.224 364.528 676.039 366.287H669.758C669.85 366.472 669.943 366.657 670.035 366.75H676.131C676.131 368.695 677.609 370.084 679.365 370.084ZM679.365 364.342C680.565 364.342 681.489 365.361 681.489 366.657C681.489 367.954 680.565 368.973 679.365 368.973C678.164 368.973 677.24 367.954 677.24 366.657C677.148 365.361 678.164 364.342 679.365 364.342Z",
    fill: "#2BBAA0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M688.787 394.716C689.987 394.716 690.911 395.735 690.911 397.031C690.911 397.309 690.911 397.494 690.819 397.772C691.096 398.05 691.373 398.42 691.65 398.698C691.927 398.235 692.02 397.679 692.02 397.031C692.02 395.086 690.542 393.512 688.694 393.512C688.232 393.512 687.77 393.605 687.309 393.79C687.586 394.16 687.863 394.438 688.14 394.809C688.417 394.716 688.602 394.716 688.787 394.716Z",
    fill: "#2BBAA0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M726.936 231.271C725.088 231.271 723.61 232.845 723.61 234.79C723.61 236.735 725.088 238.309 726.936 238.309C728.691 238.309 730.076 236.827 730.261 235.068H742.824C742.916 236.92 744.394 238.309 746.149 238.309C747.997 238.309 749.475 236.735 749.475 234.79C749.475 232.845 747.997 231.271 746.149 231.271C744.394 231.271 743.008 232.753 742.824 234.512H730.261C730.076 232.753 728.598 231.271 726.936 231.271ZM726.936 237.105C725.735 237.105 724.811 236.086 724.811 234.79C724.811 233.493 725.735 232.475 726.936 232.475C728.137 232.475 729.06 233.493 729.06 234.79C729.06 236.086 728.044 237.105 726.936 237.105ZM746.057 232.475C747.258 232.475 748.181 233.493 748.181 234.79C748.181 236.086 747.258 237.105 746.057 237.105C744.856 237.105 743.932 236.086 743.932 234.79C743.932 233.493 744.856 232.475 746.057 232.475Z",
    fill: "#2BBAA0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M784.114 194.137V210.991C782.359 211.084 781.065 212.658 781.065 214.51C781.065 216.455 782.543 218.029 784.391 218.029C786.238 218.029 787.716 216.455 787.716 214.51C787.716 212.658 786.331 211.176 784.668 210.991V194.323L799.817 178.117C799.632 178.117 799.447 178.117 799.17 178.024L784.114 194.137ZM786.515 214.418C786.515 215.714 785.592 216.733 784.391 216.733C783.19 216.733 782.266 215.714 782.266 214.418C782.266 213.121 783.19 212.102 784.391 212.102C785.592 212.102 786.515 213.214 786.515 214.418Z",
    fill: "#2BBAA0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M765.27 210.899C763.515 210.899 762.13 212.381 761.945 214.14H749.382C749.29 212.288 747.812 210.899 746.057 210.899C744.209 210.899 742.731 212.473 742.731 214.418C742.731 216.363 744.209 217.937 746.057 217.937C747.812 217.937 749.197 216.455 749.382 214.696H761.945C762.037 216.548 763.515 217.937 765.27 217.937C767.118 217.937 768.596 216.363 768.596 214.418C768.503 212.473 767.025 210.899 765.27 210.899ZM746.057 216.733C744.856 216.733 743.932 215.714 743.932 214.418C743.932 213.121 744.856 212.103 746.057 212.103C747.258 212.103 748.181 213.121 748.181 214.418C748.181 215.714 747.258 216.733 746.057 216.733ZM765.27 216.733C764.069 216.733 763.146 215.714 763.146 214.418C763.146 213.121 764.069 212.103 765.27 212.103C766.471 212.103 767.395 213.121 767.395 214.418C767.395 215.714 766.471 216.733 765.27 216.733Z",
    fill: "#2BBAA0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M688.786 390.456C690.634 390.456 692.112 388.882 692.112 386.937C692.112 384.993 690.634 383.418 688.786 383.418C687.031 383.418 685.646 384.9 685.461 386.66H681.858C681.951 386.845 682.136 387.03 682.228 387.123H685.461C685.646 389.067 687.031 390.456 688.786 390.456ZM688.786 384.715C689.987 384.715 690.911 385.734 690.911 387.03C690.911 388.326 689.987 389.345 688.786 389.345C687.585 389.345 686.662 388.326 686.662 387.03C686.662 385.734 687.585 384.715 688.786 384.715Z",
    fill: "#2BBAA0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M704.674 244.884C704.674 246.829 706.152 248.403 707.999 248.403C709.847 248.403 711.325 246.829 711.325 244.884C711.325 243.032 709.939 241.55 708.276 241.365V228.123C710.031 228.03 711.325 226.456 711.325 224.604C711.325 222.659 709.847 221.085 707.999 221.085C706.152 221.085 704.674 222.659 704.674 224.604C704.674 226.456 706.059 227.938 707.722 228.123V241.365C705.967 241.55 704.674 243.032 704.674 244.884ZM705.782 224.696C705.782 223.4 706.706 222.381 707.907 222.381C709.108 222.381 710.031 223.4 710.031 224.696C710.031 225.993 709.108 227.012 707.907 227.012C706.798 226.919 705.782 225.9 705.782 224.696ZM707.907 242.662C709.108 242.662 710.031 243.68 710.031 244.977C710.031 246.273 709.108 247.292 707.907 247.292C706.706 247.292 705.782 246.273 705.782 244.977C705.782 243.68 706.798 242.662 707.907 242.662Z",
    fill: "#2BBAA0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M698.023 248.403V268.868L678.995 289.056V322.578C677.239 322.671 675.946 324.245 675.946 326.097C675.946 328.042 677.424 329.616 679.272 329.616C681.119 329.616 682.597 328.042 682.597 326.097C682.597 324.245 681.211 322.764 679.549 322.578V289.241L698.577 269.054V248.403C700.333 248.31 701.626 246.736 701.626 244.884C701.626 242.939 700.148 241.365 698.3 241.365C696.453 241.365 694.975 242.939 694.975 244.884C694.975 246.736 696.361 248.218 698.023 248.403ZM681.396 326.005C681.396 327.301 680.473 328.32 679.272 328.32C678.071 328.32 677.147 327.301 677.147 326.005C677.147 324.708 678.071 323.69 679.272 323.69C680.473 323.782 681.396 324.801 681.396 326.005ZM698.3 242.662C699.501 242.662 700.425 243.68 700.425 244.977C700.425 246.273 699.501 247.292 698.3 247.292C697.099 247.292 696.176 246.273 696.176 244.977C696.176 243.68 697.099 242.662 698.3 242.662Z",
    fill: "#2BBAA0"
  })))), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M845.357 318.041H870.205C873.069 318.041 875.655 316.837 877.595 314.985C879.442 313.133 880.643 310.448 880.643 307.577C880.643 301.836 876.024 297.113 870.205 297.113H845.357V292.483C845.357 286.649 843.971 281.092 841.662 276.184H870.205C873.069 276.184 875.655 274.981 877.595 273.129C879.442 271.276 880.643 268.591 880.643 265.72C880.643 259.979 876.024 255.256 870.205 255.256H804.621C804.898 251.274 805.267 247.755 805.729 244.885C806.745 238.588 811.918 233.865 818.384 233.309C818.569 233.309 818.661 233.309 818.846 233.309C819.123 233.309 819.308 233.309 819.493 233.309C820.601 233.217 821.617 233.217 822.633 233.124C823.834 233.031 824.943 233.031 826.051 232.939C828.638 232.754 830.577 232.29 832.332 231.642C836.304 230.161 838.521 227.383 838.891 223.493C839.353 219.141 837.69 215.807 833.903 213.677C831.501 212.288 828.73 211.733 825.497 212.01C824.85 212.103 824.204 212.196 823.465 212.288C816.814 213.399 810.625 216.363 804.159 221.641C793.351 230.346 786.701 241.458 784.576 254.7C784.576 254.886 784.484 255.071 784.484 255.256H714.096C711.233 255.256 708.646 256.46 706.706 258.312C704.859 260.164 703.658 262.85 703.658 265.72C703.658 271.462 708.277 276.184 714.096 276.184H744.949C742.547 281.092 741.254 286.649 741.254 292.483V297.113H714.189C711.325 297.113 708.739 298.317 706.799 300.169C704.951 302.021 703.751 304.706 703.751 307.577C703.751 313.318 708.369 318.041 714.189 318.041H741.254V322.671C741.254 328.505 742.639 334.062 744.949 338.969H714.096C711.233 338.969 708.646 340.173 706.706 342.025C704.767 343.877 703.658 346.563 703.658 349.434C703.658 355.175 708.277 359.898 714.096 359.898H781.62C781.528 363.139 781.251 366.843 780.604 370.362C779.311 377.77 773.676 383.975 766.194 386.197C763.792 386.938 761.668 387.401 760.652 387.586C759.543 387.771 758.435 388.049 757.419 388.234C754.555 388.79 751.784 389.253 749.29 390.272C746.426 391.383 744.394 393.791 743.655 396.754C742.916 399.81 743.748 403.051 745.872 405.459C748.736 408.607 752.246 409.811 757.142 409.441C757.696 409.348 758.342 409.348 758.897 409.255C767.395 407.866 775.154 404.162 781.805 398.143C792.243 388.697 798.617 376.566 801.48 360.824C801.573 360.546 801.573 360.176 801.665 359.898H870.113C872.976 359.898 875.563 358.694 877.502 356.842C879.35 354.99 880.551 352.304 880.551 349.434C880.551 343.692 875.932 338.969 870.113 338.969H841.57C843.971 334.062 845.265 328.505 845.265 322.671V318.041H845.357ZM804.806 276.37C815.706 276.37 824.573 285.26 824.573 296.187V297.205H803.328C803.42 290.26 803.512 283.13 803.697 276.37H804.806ZM762.13 296.187C762.13 285.26 770.997 276.37 781.897 276.37H783.652C783.468 282.667 783.283 289.797 783.098 297.205H762.222V296.187H762.13ZM762.13 319.152V318.134H782.544C782.359 325.635 782.267 332.765 782.082 338.969H781.897C770.905 338.969 762.13 330.08 762.13 319.152ZM803.235 338.969C803.235 338.229 803.235 337.488 803.235 336.747C803.235 334.802 803.235 331.839 803.235 328.042C803.235 325.079 803.235 321.745 803.235 318.134H824.573V319.152C824.573 330.08 815.706 338.969 804.806 338.969H803.235Z",
    fill: "#F3F3F3"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M948.998 228.216C909.463 154.874 823.002 116.629 740.052 140.891C657.01 165.246 604.82 244.144 610.824 327.302C648.881 288.223 700.517 245.625 764.993 226.734C829.469 207.843 895.884 215.9 948.998 228.216Z",
    fill: "#E9E9E9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2_12269",
    transform: "scale(0.00581395)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2_12269",
    x: 425.988,
    y: 38.8701,
    width: 574.778,
    height: 568,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 67,
    result: "effect1_foregroundBlur_2_12269"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2_12269",
    x: 0.652344,
    y: 38.1406,
    width: 569.624,
    height: 568.729,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 67,
    result: "effect1_foregroundBlur_2_12269"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(354.884 457.283) scale(279.639 71.7415)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#20C1C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201,
    stopColor: "#17888C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#0E575A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5783,
    stopColor: "#083133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7452,
    stopColor: "#041617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#010606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(354.884 457.283) scale(279.658 71.7464)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#20C1C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201,
    stopColor: "#17888C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#0E575A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5783,
    stopColor: "#083133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7452,
    stopColor: "#041617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#010606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(354.885 457.284) scale(279.628 71.7386)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#20C1C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201,
    stopColor: "#17888C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#0E575A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5783,
    stopColor: "#083133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7452,
    stopColor: "#041617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#010606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(354.884 457.284) scale(279.628 71.7387)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#20C1C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201,
    stopColor: "#17888C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#0E575A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5783,
    stopColor: "#083133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7452,
    stopColor: "#041617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#010606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(786.946 459.283) scale(279.639 71.7415)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#20C1C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201,
    stopColor: "#17888C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#0E575A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5783,
    stopColor: "#083133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7452,
    stopColor: "#041617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#010606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(786.947 459.283) scale(279.658 71.7464)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#20C1C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201,
    stopColor: "#17888C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#0E575A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5783,
    stopColor: "#083133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7452,
    stopColor: "#041617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#010606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(786.947 459.284) scale(279.628 71.7386)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#20C1C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201,
    stopColor: "#17888C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#0E575A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5783,
    stopColor: "#083133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7452,
    stopColor: "#041617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#010606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(786.947 459.284) scale(279.628 71.7387)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#20C1C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201,
    stopColor: "#17888C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#0E575A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5783,
    stopColor: "#083133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7452,
    stopColor: "#041617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#010606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(477.384 278.133) rotate(-19.6348) scale(143.994)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#2092C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(477.385 278.132) rotate(-90) scale(138.011)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#2092C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201,
    stopColor: "#17678C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#0E425A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5783,
    stopColor: "#082533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7452,
    stopColor: "#041117"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#010406"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(477.385 278.133) rotate(-90) scale(138.011)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#2092C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201,
    stopColor: "#17678C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#0E425A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5783,
    stopColor: "#082533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7452,
    stopColor: "#041117"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#010406"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(477.385 278.132) rotate(-90) scale(138.01)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#2092C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201,
    stopColor: "#17678C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#0E425A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5783,
    stopColor: "#082533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7452,
    stopColor: "#041117"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#010406"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(397.282 171.632) scale(171.483 171.336)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#8000FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(876.527 219.395) scale(171.483 171.336)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#8000FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1010.93 506.45) rotate(-154.934) scale(705.814 631.908)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.277446,
    stopColor: "#1F95C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#6501C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#161C1B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(521.154 140.986) scale(2.04624 2.04817)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(600.363 202.413) scale(2.47674 2.47908)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(559.035 262.536) scale(2.84623 2.84892)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(593.767 308.798) scale(2.83566 2.83831)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(624.02 391.718) scale(2.29602 2.29819)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(624.013 464.479) scale(2.74255 2.74513)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(428.022 591.33) scale(2.57293 2.57534)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(355.428 670.424) scale(4.64294 4.64731)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(317.158 591.724) scale(5.3346 5.33962)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(263.901 519.403) scale(2.66963 2.67213)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(223.342 438.178) scale(2.65515 2.65767)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(234.456 433.213) scale(2.61172 2.61419)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(212.127 408.517) scale(3.79489 3.79846)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.813 377.775) scale(3.81531 3.81891)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(205.308 332.815) scale(3.47349 3.47677)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(223.92 301.846) scale(2.99775 3.00058)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(242.089 258.371) scale(3.44453 3.44777)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(272.088 190.295) scale(4.84878 4.85333)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(286.524 89.7345) scale(5.42691 5.43203)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(198.622 159.787) scale(4.64297 4.64734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(205.814 309.062) scale(3.23743 3.24049)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(157.487 405.583) scale(4.20703 4.21101)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(132.946 604.146) scale(3.94355 3.94726)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.7988 622.527) scale(4.64296 4.64736)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(251.27 630.298) scale(4.86973 4.87432)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(300.697 654.355) scale(4.80509 4.80962)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(302.683 670.755) scale(4.6427 4.6471)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(550.908 653.521) scale(4.64294 4.64734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(674.543 583.727) scale(3.5283 3.53167)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(510.091 392.925) scale(4.27787 4.28192)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(486.547 393.535) scale(4.64297 4.64731)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(446.167 373.732) scale(4.64297 4.64734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(456.689 285.667) scale(4.64296 4.64735)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(479.559 186.136) scale(2.06071 2.06267)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(510.292 247.332) scale(3.2917 3.29482)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(542.309 300.175) scale(3.56656 3.56993)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(556.922 329.751) scale(3.06162 3.06449)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(442.212 162.146) scale(1.92937 1.93119)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(424.265 156.322) scale(2.03434 2.03626)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(436.911 78.3202) scale(3.12701 3.12997)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(474.824 44.9591) scale(4.32516 4.32927)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(535.125 67.5218) scale(3.96863 3.97238)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(511.353 76.8754) scale(3.62706 3.6305)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(487.961 70.2114) scale(3.46496 3.46823)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(501.116 42.4158) scale(4.4925 4.49671)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(501.242 24.5516) scale(4.64297 4.64734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(386.94 86.6282) scale(4.28563 4.28967)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(373.036 95.4236) scale(4.62073 4.62508)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(363.904 63.469) scale(5.01942 5.02416)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(343.779 44.7889) scale(5.35893 5.36396)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(311.046 64.2304) scale(5.47009 5.47525)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(323.67 118.875) scale(5.67926 5.68462)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(202.817 76.7264) scale(4.64296 4.64734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(196.486 39.5142) scale(4.64296 4.64734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(306.793 219.225) scale(4.81205 4.8166)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(319.427 255.217) scale(4.37224 4.37638)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(317.375 315.531) scale(4.24295 4.24697)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint72_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(378.44 231.527) scale(4.26004 4.26405)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(449.13 227.484) scale(3.24466 3.24773)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint74_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(521.722 268.656) scale(3.70153 3.70504)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint75_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(566.93 303.439) scale(3.08665 3.08961)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint76_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(581.236 371.147) scale(2.58481 2.58728)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint77_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(581.535 420.761) scale(2.81078 2.81344)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint78_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(544.762 445.308) scale(3.84714 3.85073)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint79_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(486.827 442.534) scale(4.64271 4.64709)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint80_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(474.053 456.514) scale(4.48525 4.48947)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint81_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(548.432 402.457) scale(3.32844 3.3316)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint82_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(551.273 468.333) scale(3.93293 3.93667)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint83_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(550.675 498.373) scale(4.08474 4.08856)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint84_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(602.93 518.268) scale(3.05749 3.06036)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint85_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(488.352 551.078) scale(3.12032 3.12322)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint86_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(461.652 558.34) scale(2.57499 2.57746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint87_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(449.432 579.033) scale(2.46795 2.47027)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint88_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(404.853 575.468) scale(2.59181 2.59426)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint89_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(320.397 547.987) scale(3.79513 3.79868)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint90_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(171.776 505.26) scale(3.52235 3.52566)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint91_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(134.218 529.488) scale(4.07517 4.07901)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint92_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(100.345 507.235) scale(4.64296 4.64736)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint93_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(551.524 567.915) scale(3.92646 3.93018)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint94_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(649.996 538.875) scale(2.83227 2.83496)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint95_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(692.692 514.749) scale(3.63692 3.64034)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint96_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(629.492 563.818) scale(2.89745 2.90018)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint97_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(490.965 627.316) scale(3.83599 3.8396)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint98_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(443.99 674.124) scale(4.46197 4.46619)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint99_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(216.594 679.363) scale(4.01465 4.01842)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint100_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(335.07 626.923) scale(4.40767 4.41181)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint101_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(369.693 613.764) scale(3.97227 3.97599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint102_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(422.093 547.664) scale(2.97189 2.97468)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint103_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(474.22 500.279) scale(3.63562 3.63902)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint104_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(507.226 465.239) scale(3.99216 3.99592)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint105_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(592.322 345.501) scale(3.18981 3.19287)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint106_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(625.138 362.79) scale(3.06473 3.06758)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint107_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(579.547 210.143) scale(2.94629 2.94906)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint108_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(558.855 203.748) scale(2.96517 2.96796)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint109_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(522.465 191.611) scale(2.8739 2.87661)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint110_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(578.017 506.531) rotate(-154.505) scale(696.412 631.21)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.277446,
    stopColor: "#1F95C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#6501C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#161C1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_2_12269",
    x1: 366.152,
    y1: 87.1388,
    x2: 349.555,
    y2: 520.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D591FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "#919CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.947,
    stopColor: "#91EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_2_12269",
    x1: 198.239,
    y1: 136.083,
    x2: 554.346,
    y2: 166.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint113_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(959.054 133.646) scale(2.04624 2.0464)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint114_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1038.24 195.021) scale(2.47617 2.47695)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint115_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(996.926 255.092) scale(2.84558 2.84646)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint116_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1031.65 301.314) scale(2.83501 2.83586)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint117_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1061.9 384.163) scale(2.29549 2.29621)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint118_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1061.89 456.861) scale(2.74192 2.74276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint119_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(865.944 583.602) scale(2.57234 2.57312)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint120_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(793.366 662.628) scale(4.64188 4.6433)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint121_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(755.103 583.996) scale(5.33338 5.33501)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint122_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(701.86 511.737) scale(2.66902 2.66983)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint123_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(661.309 430.583) scale(2.65454 2.65537)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint124_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(672.421 425.622) scale(2.61112 2.61193)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint125_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(650.098 400.948) scale(3.79402 3.79519)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint126_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(645.784 370.232) scale(3.81444 3.81562)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint127_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(643.281 325.311) scale(3.47269 3.47378)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint128_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(661.887 294.368) scale(2.99706 2.99799)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint129_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(680.053 250.931) scale(3.44374 3.4448)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint130_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(710.044 182.914) scale(4.84767 4.84915)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint131_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(724.477 82.4393) scale(5.42567 5.42735)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint132_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(636.595 152.432) scale(4.64191 4.64333)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint133_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(643.787 301.578) scale(3.23669 3.23769)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint134_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(595.47 398.016) scale(4.20606 4.20738)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint135_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(570.935 596.408) scale(3.94265 3.94386)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint136_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(469.81 614.773) scale(4.6419 4.64336)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint137_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(689.232 622.537) scale(4.86861 4.87011)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint138_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(738.647 646.573) scale(4.80399 4.80547)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint139_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(740.632 662.959) scale(4.64164 4.6431)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint140_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(988.801 645.74) scale(4.64188 4.64333)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint141_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1112.41 576.006) scale(3.52749 3.52862)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint142_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(947.993 385.369) scale(4.27689 4.27823)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint143_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(924.455 385.979) scale(4.64191 4.6433)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint144_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(884.083 366.192) scale(4.64191 4.64333)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint145_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(894.604 278.203) scale(4.64189 4.64334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint146_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(917.469 178.758) scale(2.06071 2.06089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint147_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(948.195 239.901) scale(3.29095 3.29198)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint148_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(980.204 292.698) scale(3.56575 3.56685)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint149_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(994.814 322.249) scale(3.06092 3.06185)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint150_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(880.131 154.789) scale(1.92937 1.92953)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint151_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(862.187 148.97) scale(2.03434 2.03451)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint152_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(874.83 71.0354) scale(3.1263 3.12727)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint153_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(912.735 37.703) scale(4.32417 4.32553)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint154_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(973.022 60.246) scale(3.96773 3.96895)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint155_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(949.255 69.592) scale(3.62623 3.62736)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint156_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(925.867 62.9335) scale(3.46417 3.46524)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint157_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(939.02 35.1615) scale(4.49147 4.49283)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint158_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(939.147 17.3128) scale(4.64191 4.64333)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint159_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(824.871 79.3364) scale(4.28465 4.28597)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint160_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(810.97 88.1238) scale(4.61968 4.62109)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint161_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(801.84 56.1971) scale(5.01827 5.01982)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint162_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(781.719 37.5327) scale(5.35771 5.35934)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint163_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(748.994 56.9576) scale(5.46883 5.47053)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint164_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(761.614 111.555) scale(5.67796 5.67972)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint165_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(640.79 69.4427) scale(4.64189 4.64333)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint166_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(634.46 32.2622) scale(4.64189 4.64333)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint167_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(744.741 211.818) scale(4.81095 4.81244)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint168_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(757.374 247.779) scale(4.37124 4.37261)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint169_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(755.32 308.042) scale(4.24198 4.24331)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint170_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(816.373 224.11) scale(4.25907 4.26037)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint171_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(887.046 220.071) scale(3.24391 3.24493)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint172_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(959.621 261.207) scale(3.70068 3.70184)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint173_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1004.82 295.96) scale(3.08594 3.08694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint174_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1019.12 363.609) scale(2.58422 2.58505)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint175_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1019.42 413.18) scale(2.81014 2.81101)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint176_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(982.657 437.706) scale(3.84626 3.84741)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint177_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(924.735 434.935) scale(4.64165 4.64308)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint178_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(911.964 448.903) scale(4.48422 4.4856)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint179_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(986.325 394.893) scale(3.32768 3.32873)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint180_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(989.166 460.712) scale(3.93203 3.93327)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint181_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(988.567 490.726) scale(4.08381 4.08503)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint182_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1040.81 510.603) scale(3.05679 3.05772)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint183_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(926.26 543.385) scale(3.1196 3.12053)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint184_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(899.565 550.641) scale(2.5744 2.57524)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint185_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(887.348 571.315) scale(2.46738 2.46814)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint186_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(842.78 567.754) scale(2.59122 2.59202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint187_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(758.344 540.296) scale(3.79426 3.79541)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint188_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(609.756 497.607) scale(3.52155 3.52262)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint189_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(572.207 521.813) scale(4.07424 4.07549)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint190_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(538.342 499.58) scale(4.6419 4.64336)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint191_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(989.416 560.207) scale(3.92556 3.92679)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint192_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1087.87 531.193) scale(2.83162 2.83251)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint193_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1130.55 507.088) scale(3.63609 3.6372)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint194_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1067.37 556.115) scale(2.89679 2.89768)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint195_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(928.872 619.558) scale(3.83512 3.83629)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint196_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(881.907 666.325) scale(4.46094 4.46234)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint197_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(654.564 671.559) scale(4.01373 4.01495)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint198_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(773.013 619.165) scale(4.40666 4.40801)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint199_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(807.627 606.017) scale(3.97136 3.97256)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint200_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(860.015 539.974) scale(2.97121 2.97212)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint201_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(912.13 492.63) scale(3.63479 3.63588)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint202_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(945.129 457.621) scale(3.99125 3.99247)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint203_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1030.21 337.986) scale(3.18908 3.19012)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint204_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1063.01 355.26) scale(3.06402 3.06494)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint205_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1017.43 202.745) scale(2.94562 2.94651)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint206_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(996.746 196.355) scale(2.96449 2.9654)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint207_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(960.365 184.229) scale(2.87324 2.87413)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00190405,
    stopColor: "#00FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841349,
    stopColor: "#00CBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    stopColor: "#009C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#007270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#004F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#003231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5639,
    stopColor: "#001C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#000C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8131,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_2_12269",
    x1: 789.51,
    y1: 124.258,
    x2: 789.51,
    y2: 443.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_2_12269",
    x1: 789.51,
    y1: 180.293,
    x2: 789.51,
    y2: 681.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint210_radial_2_12269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(830.68 162.639) rotate(102.967) scale(264.316 267.028)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00697311,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_2_12269",
    x1: 789.511,
    y1: 322.137,
    x2: 789.511,
    y2: 37.9858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_2_12269",
    x1: 789.51,
    y1: 452.429,
    x2: 789.51,
    y2: 130.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_2_12269",
    x1: 789.511,
    y1: 171.769,
    x2: 789.511,
    y2: 527.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2_12269",
    width: 172,
    height: 172,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDualToken);
export default __webpack_public_path__ + "static/media/dual-token.9e08d89e3dcb5326a91e22d9a9205925.svg";
export { ForwardRef as ReactComponent };